/** Armenian extra dashboard strings (extra-en + extra-en-mgmt). */
export const extraHy = {
  common: {
    close: 'Փակել',
    show: 'Ցուցադրել',
    hide: 'Թաքցնել',
    showPassword: 'Ցուցադրել գաղտնաբառը',
    hidePassword: 'Թաքցնել գաղտնաբառը',
    keep: 'Պահել',
    yes: 'Այո',
    back: 'Հետ',
    dismiss: 'Փակել',
    edit: 'Խմբագրել',
    undo: 'Հետարկել',
    prev: '← Նախորդ',
    next: 'Հաջորդ →',
    pageOf: '{{page}} / {{count}}',
    showing: 'Ցուցադրվում է {{from}}–{{to}}՝ {{total}}-ից',
    exportCsv: 'Արտահանել CSV',
    importing: 'Ներմուծում…',
    saving: 'Պահպանում…',
    creating: 'Ստեղծում…',
    on: 'Միացված',
    off: 'Անջատված',
    active: 'Ակտիվ',
    inactive: 'Անգործուն',
    hidden: 'Թաքնված',
    never: 'Երբեք',
    all: 'Բոլորը',
    unknown: 'Անհայտ',
    noMatches: 'Համընկնումներ չկան',
    include: 'Ներառել',
    exclude: 'Բացառել',
    selectAll: 'Ընտրել բոլորը',
    clear: 'Մաքրել',
    filterMode: 'Զտման ռեժիմ',
    actions: 'Գործողություններ',
    confirmDelete: 'Հաստատել ջնջումը',
    newPassword: 'Նոր գաղտնաբառ',
    countryCode: 'Երկրի կոդ',
    emptyDash: '—',
    dateRange: {
      ariaLabel: 'Ժամանակահատված',
      from: 'Սկսած',
      to: 'Մինչև',
      today: 'Այսօր',
      days7: '7 օր',
      days30: '30 օր',
      days90: '90 օր',
      thisMonth: 'Այս ամիս',
      lastMonth: 'Անցած ամիս',
      thisYear: 'Այս տարի',
      allTime: 'Ամբողջ ժամանակ',
      custom: 'Անհատական',
    },
  },
  nav: {
    groups: {
      insights: 'Վերլուծություն',
      books: 'Հաշվապահություն',
      operations: 'Գործառնություններ',
      management: 'Կառավարում',
      crm: 'CRM',
      system: 'Համակարգ',
      admin: 'Ադմինիստրացիա',
    },
    language: 'Լեզու',
    openMenu: 'Բացել ընտրացանկը',
    themeLight: 'Անցնել լուսավոր ռեժիմ',
    themeDark: 'Անցնել մուգ ռեժիմ',
    books: 'Արտահանում',
    role: {
      owner: 'սեփականատեր',
      admin: 'ադմինիստրատոր',
      manager: 'կառավարիչ',
      accountant: 'հաշվապահ',
      super_admin: 'գերադմինիստրատոր',
      anon: 'անանուն',
    },
  },
  auth: {
    createAccount: 'Ստեղծել հաշիվ',
    accountCreated: 'Հաշիվը ստեղծված է։ Այժմ կարող եք մուտք գործել։',
    needAccount: 'Հաշիվ չունե՞ք։ Գրանցվեք',
    haveAccount: 'Արդեն հաշիվ ունե՞ք։ Մուտք գործեք',
    notConfiguredBody: 'Ստեղծեք Supabase նախագիծ, ապա պատճենեք apps/dashboard/.env.example-ը որպես apps/dashboard/.env և լրացրեք VITE_SUPABASE_URL ու VITE_SUPABASE_ANON_KEY։ Վերագործարկեք մշակման սպասարկիչը։',
    noRoleBodyExtended: 'Այս հաշիվը դեռ դեր չունի։ Խնդրեք գերադմինիստրատորին տրամադրել այն, կամ գործարկեք գերադմինիստրատորի նախնական SQL-ը։',
  },
  wasteReasons: {
    expired: 'Ժամկետանց',
    spoiled: 'Փչացած',
    quality_issue: 'Որակի խնդիր',
    non_saleable: 'Չվաճառվող',
    prep_waste: 'Պատրաստման թափոն',
    burnt: 'Այրված',
    spillage: 'Թափված',
    damaged: 'Վնասված',
    staff_meal: 'Աշխատակցի սնունդ',
    other: 'Այլ',
  },
  landing: {
    signIn: 'Մուտք',
    lead: 'Սրճարանների POS համակարգ հայկական սրճարանների համար։',
    downloads: {
      "macos-arm64": 'Mac (Apple silicon)',
      "macos-x64": 'Mac (Intel)',
      "windows-x64": 'Windows',
    },
  },
  dashboard: {
    title: 'Վահանակ',
    loading: 'Վահանակը բեռնվում է…',
    loadFailed: 'Բեռնումը ձախողվեց',
    couldntLoad: 'Չհաջողվեց բեռնել վահանակը',
    revenueToday: 'Այսօրվա եկամուտ',
    ordersToday: 'Այսօրվա պատվերներ',
    averageOrder: 'Միջին պատվեր',
    coversToday: 'Այսօրվա հյուրեր',
    givenAwayToday: 'Այսօր անվճար տրված',
    tipsToday: 'Քարտային թեյավճարներ',
    staffToday: 'Այսօրվա անձնակազմ',
    staffWage: 'Աշխատավարձ',
    staffTodayEmpty: 'Այսօր ժամանակացույցում ոչ ոք չկա։',
    bookingsToday: 'Այսօրվա ամրագրումներ',
    bookingsInHouse: 'Տեղում',
    bookingsArriving: 'Ժամանում',
    bookingsLeaving: 'Մեկնում',
    bookingsPending: 'Սպասում',
    categoryShare: 'Այսօր ըստ կատեգորիայի',
    noCategorySales: 'Այսօր վաճառք չկա։',
    uncategorised: 'Առանց կատեգորիայի',
    vsYesterday: 'համեմատած երեկվա հետ',
    revenueChart: 'Եկամուտ',
    last30: 'Վերջին 30 օրը',
    paymentSplit: 'Վճարումների բաշխում',
    noPayments30: 'Վերջին 30 օրվա ընթացքում վճարումներ չկան։',
    cash: 'Կանխիկ',
    card: 'Քարտ',
    ordersByHour: 'Պատվերներ ըստ ժամի',
    last7: 'Վերջին 7 օրը',
    orders: 'Պատվերներ',
    topProducts: 'Առաջատար ապրանքներ',
    topProductsCaption: 'Վերջին 30 օրը՝ ըստ եկամտի',
    noSales30: 'Վերջին 30 օրվա ընթացքում վաճառք չկա։',
    stockIn: 'Պաշարի մուտք',
    lowStock: 'Ցածր պաշար',
    lowStockCaption: '{{count}} բաղադրիչ շեմին կամ դրանից ցածր',
    lowStockNegative: ' · {{count}} բացասական',
    prep: 'Նախապատրաստում',
    threshold: 'Շեմ՝ {{value}}',
  },
  sales: {
    title: 'Վաճառք',
    subtitleRange: '{{from}} – {{to}} · {{comparison}}',
    tabRevenue: 'Եկամուտ',
    tabOrders: 'Պատվերներ',
    loadFailed: 'Բեռնումը ձախողվեց',
    couldntLoad: 'Չհաջողվեց բեռնել վաճառքը',
    vsYesterday: 'համեմատած երեկվա հետ',
    vsPrevious7: 'համեմատած նախորդ 7 օրվա հետ',
    vsPrevious30: 'համեմատած նախորդ 30 օրվա հետ',
    vsPrevious90: 'համեմատած նախորդ 90 օրվա հետ',
    vsMonthBefore: 'համեմատած նախորդ ամսվա հետ',
    vsSameSpanLastYear: 'համեմատած անցած տարվա նույն ժամանակահատվածի հետ',
    vsPreviousPeriod: 'համեմատած նախորդ ժամանակահատվածի հետ',
    revenue: 'Եկամուտ',
    paidOrders: 'Վճարված պատվերներ',
    averageOrder: 'Միջին պատվեր',
    covers: 'Հյուրեր',
    revenuePerCover: 'Եկամուտ մեկ հյուրի համար',
    cardTips: 'Քարտային թեյավճարներ',
    tipRateOnCard: 'Թեյավճարի տոկոս քարտով պատվերներում',
    averageTipWhenTipped: 'Միջին թեյավճար, երբ տրվել է',
    note: 'Եկամուտը և միջին պատվերը միայն ապրանքներն են. քարտային թեյավճարները հաշվառվում են առանձին։ Վճարումների բաշխման մեջ թեյավճարները ներառված են քարտի գումարում։',
    revenueTrend: 'Եկամտի միտում',
    byHour: 'Ըստ ժամի',
    byDay: 'Ըստ օրվա',
    paymentSplit: 'Վճարումների բաշխում',
    noPaymentData: 'Վճարման տվյալներ չկան։',
    cash: 'Կանխիկ',
    card: 'Քարտ',
    forceCloseByReason: 'Հարկադիր փակում ըստ պատճառի',
    noForceClosed: 'Այս ժամանակահատվածում հարկադրաբար փակված պատվերներ չկան։',
    reasonMistake: 'սխալ',
    reasonSystemError: 'համակարգային սխալ',
    reasonFree: 'անվճար',
    reasonOther: 'այլ',
    allOrders: 'Բոլոր պատվերները',
    paid: 'Վճարված',
    refunded: 'Վերադարձված',
    void: 'Չեղարկված',
    forceClosed: 'Հարկադրաբար փակված',
    refundRate: 'Վերադարձի տոկոս',
    forceCloseRate: 'Հարկադիր փակման տոկոս',
    orderQuality: 'Պատվերի որակ',
    avgItems: 'Միջին ապրանքներ պատվերում',
    modifierAttach: 'Հավելումների կցման տոկոս',
    paidShare: 'Վճարված պատվերների մասնաբաժին',
    totalCovers: 'Ընդհանուր հյուրեր',
  },
  orders: {
    title: 'Պատվերներ',
    subtitleFiltered: '{{filtered}}՝ {{total}}-ից',
    subtitleTotal: '{{amount}} ընդամենը',
    subtitlePaid: '({{amount}} վճարված)',
    live: '● Կենդանի',
    liveUpdates: 'Կենդանի թարմացում',
    closeReason: 'Փակման պատճառ',
    compType: 'Անվճարի տեսակ',
    compRecipient: 'Անվճար ստացող',
    reprint: 'Կրկին տպել',
    reprintTitle: 'Կրկին տպել կտրոնը',
    searchPlaceholder: 'Որոնել ըստ համարի, նույնացուցիչի, TIN…',
    allStatuses: 'Բոլոր կարգավիճակները',
    statusOpen: 'բաց',
    statusPaid: 'վճարված',
    statusVoid: 'չեղարկված',
    statusRefunded: 'վերադարձված',
    paymentUnpaid: 'չվճարված',
    paymentPartial: 'մասնակի',
    allCompTypes: 'Բոլոր անվճար տեսակները',
    allRecipients: 'Բոլոր ստացողները',
    menuItems: 'Մենյուի ապրանքներ',
    searchMenu: 'Որոնել մենյուում…',
    inactiveSuffix: ' (անգործուն)',
    paymentType: 'Վճարման տեսակ',
    all: 'Բոլորը',
    cash: 'Կանխիկ',
    card: 'Քարտ',
    shiftId: 'Հերթափոխի նույնացուցիչ',
    clearShift: 'Մաքրել հերթափոխի զտիչը',
    forcedOnly: 'Միայն հարկադրաբար փակված',
    missingPayments: '{{count}} վճարված պատվեր առանց վճարման գրառման',
    colNumber: '#',
    colTime: 'Ժամանակ',
    colStatus: 'Կարգավիճակ',
    colPayment: 'Վճարում',
    colTotal: 'Ընդամենը',
    colCashierShift: 'Դրամարկղավար / հերթափոխ',
    colTin: 'TIN',
    colComp: 'Անվճար',
    colForced: 'Հարկադիր',
    missing: 'բացակայում է',
    missingTitle: 'Այս պատվերի համար վճարման գրառում չկա',
    pay: 'վճարում',
    payMismatch: 'Վճարումը {{paid}} ≠ սպասված {{expected}} (պարտք՝ {{due}})',
    payMismatchTip: 'Վճարումը {{paid}} ≠ սպասված {{expected}} (պարտք՝ {{due}} + թեյավճար {{tip}})',
    fiscal: 'ֆիսկալ',
    fiscalMismatch: 'Գանձվել է {{charged}}, բայց ֆիսկալ կտրոնում նշված է {{fiscal}}',
    inclLoyalty: 'ներառյալ −{{amount}} հավատարմություն',
    plusTip: '+ {{amount}} թեյավճար',
    goToShift: 'Անցնել այս հերթափոխին',
    empty: 'Այս զտիչներին համապատասխան պատվերներ չկան։',
    detailTitle: 'Պատվեր #{{number}}',
    cashier: 'Դրամարկղավար',
    closedBy: 'Փակել է',
    shift: 'Հերթափոխ',
    openShift: 'Բաց հերթափոխ',
    forceClosed: 'Հարկադրաբար փակված',
    noReason: 'պատճառ չկա',
    unknownRecipient: 'Անհայտ',
    loyalty: 'Հավատարմություն',
    member: 'Անդամ',
    removedMember: 'Հեռացված անդամ',
    discount: 'Զեղչ',
    pointsRedeemed: 'Օգտագործված միավորներ',
    totals: 'Ընդամենը',
    itemsSubtotal: 'Ապրանքների ենթագումար',
    loyaltyDiscount: 'Հավատարմության զեղչ',
    amountDue: 'Վճարման ենթակա',
    cardTip: 'Քարտային թեյավճար',
    charged: 'Գանձված',
    items: 'Ապրանքներ',
    colName: 'Անուն',
    colQty: 'Քանակ',
    colUnitPrice: 'Միավորի գին',
    colDiscount: 'Զեղչ',
    colLineTotal: 'Տողի գումար',
    noItems: 'Այս պատվերում ապրանքներ չկան։',
    payments: 'Վճարումներ',
    colMethod: 'Եղանակ',
    colAmount: 'Գումար',
    noPayments: 'Վճարումներ չեն գրանցվել։',
    fiscalTitle: 'Ֆիսկալ կտրոն',
    fiscalMatches: 'Ֆիսկալ գումարը {{fiscal}} համընկնում է գանձված {{charged}}-ի հետ։',
    fiscalMismatchTitle: 'Ֆիսկալ անհամապատասխանություն',
    fiscalMismatchBody: 'գանձվել է {{charged}}, բայց HDM ֆիսկալ կտրոնում նշված է {{fiscal}} (տարբերություն՝ {{gap}})։ Տպված ֆիսկալ գումարը կարող է չհամընկնել հավաքվածի հետ։',
    fiscalNumber: 'Ֆիսկալ #',
    fiscalTotal: 'Ֆիսկալ գումար',
    change: 'Մանրադրամ',
    csvNumber: 'number',
    csvCreated: 'created_at',
    csvStatus: 'status',
    csvPayment: 'payment_status',
    csvTotal: 'total',
    csvForced: 'forced_close',
    csvCloseReason: 'close_reason',
    csvCompType: 'comp_type',
    csvCompRecipient: 'comp_recipient',
    csvTin: 'partner_tin',
    csvShift: 'shift_id',
    csvId: 'id',
  },
  shifts: {
    title: 'Հերթափոխներ',
    subtitle: '{{count}} հերթափոխ',
    paymentMethod: 'Վճարման եղանակ',
    all: 'Բոլորը',
    cash: 'Կանխիկ',
    card: 'Քարտ',
    overallTotal: 'Ընդհանուր գումար',
    cashTotal: 'Կանխիկ գումար',
    cardTotal: 'Քարտային գումար',
    empty: 'Այս ժամանակահատվածում հերթափոխներ չկան։',
    colOpened: 'Բացված',
    colClosed: 'Փակված',
    colCashier: 'Դրամարկղավար',
    colOrders: 'Պատվերներ',
    colVoid: 'Չեղարկված',
    colForced: 'Հարկադիր',
    colTotal: 'Ընդամենը',
    colCash: 'Կանխիկ',
    colCard: 'Քարտ',
    colStatus: 'Կարգավիճակ',
    showBreakdown: 'Ցուցադրել բաշխումը',
    statusOpen: 'բաց',
    statusClosed: 'փակ',
    shiftId: 'Հերթափոխի նույնացուցիչ',
    openingFloat: 'Բացման կանխիկ',
    paidOrders: 'Վճարված պատվերներ',
    paidOf: '{{paid}}՝ {{total}}-ից',
    viewOrders: 'Դիտել պատվերները →',
    reassign: 'Փոխել դրամարկղավարին',
    selectCashier: '— ընտրել դրամարկղավար —',
    cashierHdm: ' (HDM #{{no}})',
    cashierNoHdm: ' · HDM համար չկա',
    reassignNoHdm: 'Ընտրված դրամարկղավարը HDM համար չունի — նախ նշեք այն «Դրամարկղավարներ» բաժնում։',
    paymentBreakdown: 'Վճարումների բաշխում',
    noPayments: 'Վճարումներ չեն գրանցվել։',
    colMethod: 'Եղանակ',
    grandTotal: 'Ընդհանուր գումար',
    unrecorded: '{{amount}} չգրանցված — որոշ պատվերների վճարման գրառումները բացակայում են։ Պատվերների հիմքով գումար՝ {{orderTotal}}',
    expenses: 'Ծախսեր / կանխիկի ելք',
    noExpenses: 'Ծախսեր չեն գրանցվել։',
    colCategory: 'Կատեգորիա',
    colDescription: 'Նկարագրություն',
    colAddedBy: 'Ավելացրել է',
    colAmount: 'Գումար',
    total: 'Ընդամենը',
    addExpense: '+ Ավելացնել ծախս',
    amountAmd: 'Գումար (AMD)',
    descriptionPlaceholder: 'օրինակ՝ գիշերային տաքսի աշխատակիցների համար',
    errorPositive: 'Մուտքագրեք դրական գումար։',
    errorDescription: 'Նկարագրությունը պարտադիր է։',
    catTaxi: 'տաքսի',
    catSupplies: 'պարագաներ',
    catMeals: 'սնունդ',
    catDelivery: 'առաքում',
    catOther: 'այլ',
    expectedCash: 'Սպասվող կանխիկ դրամարկղում',
    expectedFormula: '{{cashSales}} կանխիկ վաճառք − {{expenses}} ծախս = {{result}}',
  },
  cashDrops: {
    title: 'Կանխիկի հանձնում',
    subtitle: 'Օրվա վերջի կանխիկ՝ հավաքելու համար · միայն սեփականատեր/ադմինիստրատոր',
    refreshExpected: 'Թարմացնել սպասվող գումարները',
    syncing: 'Համաժամեցում…',
    markCollected: 'Նշել որպես հավաքված',
    waiting: '{{count}} հանձնում սպասում է',
    expectedTotal: 'Սպասվող ընդամենը՝ {{amount}}',
    syncFailed: 'Համաժամեցումը ձախողվեց',
    invalidCounted: 'Մուտքագրեք վավեր հաշված գումար։',
    colDay: 'Օր',
    colExpected: 'Սպասվող',
    colCounted: 'Հաշված',
    colStatus: 'Կարգավիճակ',
    colCollected: 'Հավաքված',
    colCollectedBy: 'Հավաքել է',
    showExpenses: 'Ցուցադրել ծախսերը',
    hideExpenses: 'Թաքցնել ծախսերը',
    expenseSummary: '{{count}} ծախս · −{{amount}}',
    pending: 'Սպասման մեջ',
    collected: 'Հավաքված',
    empty: 'Կանխիկի հանձնումներ դեռ չկան։ Սեղմեք «Թարմացնել սպասվող գումարները»՝ կանխիկ վաճառքից ստեղծելու համար։',
    cashSales: 'Կանխիկ վաճառք',
    expenses: 'Ծախսեր',
    expected: 'Սպասվող',
    colTime: 'Ժամանակ',
    colCategory: 'Կատեգորիա',
    colDescription: 'Նկարագրություն',
    colBy: 'Կատարել է',
    colAmount: 'Գումար',
    catTaxi: 'Տաքսի',
    catSupplies: 'Պարագաներ',
    catMeals: 'Սնունդ',
    catDelivery: 'Առաքում',
    catOther: 'Այլ',
    collectTitle: 'Հավաքել հանձնումը — {{day}}',
    expectedLabel: 'Սպասվող՝ {{amount}}',
    countedLabel: 'Հաշված գումար (֏)',
    noteLabel: 'Նշում (ոչ պարտադիր)',
    confirm: 'Հաստատել հավաքումը',
  },
  inventoryInsights: {
    title: 'Պաշարներ',
    subtitle: 'Կորուստ, պաշարի վիճակ, շարժեր և հոսք',
    tabLoss: 'Կորուստ և շեղում',
    tabStock: 'Պաշարի վիճակ',
    tabTransactions: 'Գործարքներ',
    tabFlow: 'Պաշարի հոսք',
    loadFailed: 'Բեռնումը ձախողվեց',
    notConfigured: 'Կարգավորված չէ',
    couldntLoad: 'Չհաջողվեց բեռնել պաշարները',
    stockOverview: 'Պաշարի ընդհանուր պատկեր',
    totalCount: '{{count}} ընդամենը',
    lowCount: '{{count}} ցածր',
    criticalCount: '{{count}} կրիտիկական',
    searchIngredient: 'Որոնել բաղադրիչ…',
    colIngredient: 'Բաղադրիչ',
    colStock: 'Պաշար',
    colThreshold: 'Շեմ',
    colStatus: 'Կարգավիճակ',
    statusOk: 'Լավ',
    statusLow: 'Ցածր',
    statusCritical: 'Կրիտիկական',
    noResults: 'Արդյունք չկա',
    mostDepleted: 'Ամենաշատ սպառված (ամբողջ ժամանակ)',
    depleted: 'Սպառված',
    txLog: 'Գործարքների մատյան ({{count}} գրառում)',
    typeSale: 'Վաճառք',
    typeRestock: 'Համալրում',
    typeAdjustment: 'Ուղղում',
    typeWaste: 'Թափոն',
    typeStockCount: 'Պաշարի հաշվարկ',
    typeCountRevert: 'Հաշվարկի հետարկում',
    typeWasteRevert: 'Թափոնի չեղարկում',
    typeInvoice: 'Հաշիվ-ապրանքագիր',
    typeInvoiceRevert: 'Հաշիվ-ապրանքագրի հետարկում',
    typePrep: 'Նախապատրաստում',
    typeForceClose: 'Հարկադիր փակում',
    colDate: 'Ամսաթիվ',
    colType: 'Տեսակ',
    colDelta: 'Տարբերություն',
    colNote: 'Նշում',
    noTransactions: 'Գործարքներ չկան',
    colStockIn: 'Պաշարի մուտք',
    colStockOut: 'Պաշարի ելք',
    colNet: 'Զուտ',
    selectRange: 'Վերևում ընտրեք ժամանակահատված։',
    noTxPeriod: 'Այս ժամանակահատվածում գործարքներ չկան։',
    allIngredients: 'Բոլոր բաղադրիչները',
    categoryAll: 'Բոլորը',
    categoryWaste: 'Թափոն',
    categoryUnknown: 'Անհայտ',
    lossRate: 'Կորստի տոկոս',
    netLoss: 'Զուտ {{pct}}% · −{{amount}}',
    formula: '(Թափոն + Անհայտ ↓) ÷ մուտքային պաշարի արժեք',
    benchmark: 'Նպատակ՝ գնումների 2–5%-ից ցածր · Պաշարի մուտք՝ {{amount}}',
    waste: 'Թափոն',
    unknownDown: 'Անհայտ ↓',
    unknownUp: 'Անհայտ ↑',
    ofStockIn: 'պաշարի մուտքի {{pct}}%-ը',
    recovered: 'Վերականգնված հաշվարկներով',
    periodFlow: 'Ժամանակահատվածի հոսք (արժեք)',
    stockIn: 'Պաշարի մուտք',
    dailyTrend: 'Օրական կորստի միտում',
    trendLegend: 'Սյուներ՝ կորստի արժեք · Գիծ՝ պաշարի մուտքի %',
    noLoss: 'Այս ժամանակահատվածում կորստի դեպքեր չկան։',
    topLoss: 'Առավել կորուստ ունեցող ապրանքներ',
    byValueAll: 'Ըստ արժեքի · թափոն + անհայտ ↓',
    byValueWaste: 'Ըստ արժեքի · միայն թափոն',
    byValueUnknown: 'Ըստ արժեքի · միայն անհայտ ↓',
    noLossItems: 'Այս ժամանակահատվածում կորստի ապրանքներ չկան։',
    noLoggedWaste: 'Այս ժամանակահատվածում գրանցված թափոն չկա։',
    noUnknown: 'Այս ժամանակահատվածում անհայտ շեղումներ չկան։',
    wasteByReason: 'Թափոն ըստ պատճառի',
    wasteOnly: 'Միայն գրանցված թափոն',
    wasteFilterOff: 'Թափոնի զտիչը միացված չէ',
    selectWasteOrAll: 'Պատճառները տեսնելու համար ընտրեք «Թափոն» կամ «Բոլորը»։',
    vsDown: 'Պաշարի մուտքը և նվազող շեղումը',
    vsUp: 'Պաշարի մուտքը և աճող շեղումը',
    modeQty: 'Քանակ',
    modeValue: 'Արժեք',
    mixedUnits: 'Խառը միավորներ — քանակները պիտակավորելու համար զտեք ըստ բաղադրիչի։',
    noDataPeriod: 'Այս ժամանակահատվածում տվյալներ չկան։',
    varianceDown: 'Նվազող շեղում',
    varianceUp: 'Աճող շեղում',
    lossEvents: 'Կորստի դեպքեր',
    wasteEvents: 'Թափոնի դեպքեր',
    unknownEvents: 'Անհայտ շեղման դեպքեր',
    colWhen: 'Երբ',
    colCategory: 'Կատեգորիա',
    colValue: 'Արժեք',
    colDetails: 'Մանրամասներ',
    catWaste: 'Թափոն',
    catUnknown: 'Անհայտ',
    catReverted: 'Հետարկված',
    noLossData: 'Այս ժամանակահատվածում կորստի տվյալներ չկան։',
    netLossLabel: 'Զուտ կորուստ',
    varianceRatio: '{{label}} = պաշարի մուտքի {{pct}}%-ը',
    stockInPct: 'Պաշարի մուտք {{pct}}%',
    compareAria: 'Պաշարի մուտք {{stockPct}}%, {{label}} {{varPct}}%',
    tooltipWaste: 'Թափոն՝ −{{amount}}',
    tooltipUnknownDown: 'Անհայտ ↓՝ −{{amount}}',
    tooltipTotalLoss: 'Ընդհանուր կորուստ՝ −{{amount}}',
    tooltipLossRate: 'Կորստի տոկոս՝ պաշարի մուտքի {{pct}}%-ը',
    wasteAmount: 'Թափոն −{{amount}}',
    unknownAmount: 'Անհայտ −{{amount}}',
    wasSystemCounted: 'Համակարգային էր {{system}} → հաշված {{counted}} {{unit}}',
    systemCounted: 'Համակարգային {{system}} → հաշված {{counted}} {{unit}}',
  },
  menuInsights: {
    title: 'Մենյուի վերլուծություն',
    subtitle: 'Ինչ է վաճառվում, ինչ է վաստակում և ինչ պետք է ուղղել',
    tabProducts: 'Ապրանքներ',
    tabCategories: 'Կատեգորիաներ',
    loadFailed: 'Բեռնումը ձախողվեց',
    notConfigured: 'Կարգավորված չէ',
    couldntLoad: 'Չհաջողվեց բեռնել մենյուի վերլուծությունը',
    vatTaxable: 'ԱԱՀ-ով հարկվող',
    vatExempt: 'ԱԱՀ-ից ազատված',
    turnoverTax: 'Շրջանառության հարկ',
    uncategorised: 'Առանց կատեգորիայի',
    unknownDept: 'Անհայտ',
    deptPrefix: 'Բաժին {{id}}',
    dailyByItem: 'Օրական վաճառք ըստ ապրանքի',
    dailyByCategory: 'Օրական վաճառք ըստ կատեգորիայի',
    noSales: 'Այս ժամանակահատվածի համար վաճառքի տվյալներ չկան։',
    selectItem: 'Գծապատկերը ցուցադրելու համար ընտրեք առնվազն մեկ ապրանք։',
    include: 'Ներառել',
    includeCount: '{{selected}} / {{total}} ներառված',
    chartTotal: 'Ընդամենը՝ {{amount}} · {{count}} շարք ներառված',
    filterAll: 'Բոլորը',
    filterNone: 'Ոչ մեկը',
    noMatches: 'Համընկնում չկա',
    modeRevenue: 'Եկամուտ',
    modeQuantity: 'Քանակ',
    pctOfDay: 'օրվա {{pct}}%-ը',
    topProducts: 'Առաջատար ապրանքներ',
    byRevenue: 'Ըստ եկամտի',
    byQty: 'Ըստ քանակի',
    bottomSellers: 'Ամենաթույլ վաճառք (վերջին 5-ը)',
    revenueByCategory: 'Եկամուտ ըստ կատեգորիայի',
    categoryShare: 'Կատեգորիայի մասնաբաժին',
    revenueByDept: 'Եկամուտ ըստ բաժնի / հարկի տեսակի',
    tooltipRevenue: 'Եկամուտ',
  },
  staffInsights: {
    title: 'Անձնակազմի վերլուծություն',
    subtitle: 'Ժամեր, աշխատավարձ և յուրաքանչյուրի մասնաբաժինը թեյավճարից։',
    loadFailed: 'Բեռնումը ձախողվեց',
    notConfigured: 'Կարգավորված չէ',
    couldntLoad: 'Չհաջողվեց բեռնել անձնակազմի վերլուծությունը',
    empty: 'Աշխատակիցներ դեռ չկան։ Ավելացրեք մարդկանց և նրանց ժամերը Աշխատակիցներ էջում։',
    noHours: 'Այս միջակայքում ժամեր չկան, ուստի թեյավճարը չի բաժանվում։',
    tipExplain: 'Վճարված պատվերների թեյավճարը բաժանվում է ըստ ժամերի։ Աշխատավարձը հաշվվում է այդ օրվա դրույքով։',
    chartTitle: 'Աշխատավարձ',
    chartTips: 'Թեյավճար',
    hours: 'Ժամեր',
    wages: 'Աշխատավարձ',
    tipPool: 'Թեյավճար',
    totalPay: 'Ընդամենը',
    colName: 'Անուն',
    colHours: 'Ժամեր',
    colShare: 'Ժամերի մասնաբաժին',
    colWage: 'Աշխատավարձ',
    colTip: 'Թեյավճար',
    colTotal: 'Ընդամենը',
  },
  businessHealth: {
    title: 'Բիզնեսի վիճակ',
    subtitle: 'Շահութաբերություն, անվնասության շեմ և մենյուի արդյունք',
    monthAria: 'Ամիս',
    loadFailed: 'Բեռնումը ձախողվեց',
    couldntLoad: 'Չհաջողվեց բեռնել բիզնեսի վիճակը',
    profitable: 'Այս ամիս շահութաբեր է',
    losing: 'Այս ամիս վնասով է',
    biggestCost: 'Ամենամեծ ծախսը՝ {{label}} ({{amount}}, եկամտի {{pct}}%-ը)',
    revenue: 'Եկամուտ',
    grossMargin: 'Համախառն մարժա',
    netMargin: 'Զուտ մարժա',
    covers: 'Հյուրեր',
    paidOrders: 'Վճարված պատվերներ',
    plTitle: 'Շահույթի և վնասի բաշխում',
    helpRevenue: 'Եկամուտ — այս ամսվա վճարված պատվերների գումարը (paid_at)։',
    helpHow: 'Ինչպե՞ս է հաշվարկվում {{title}}-ը։',
    helpCogs: 'Սննդի ինքնարժեք (COGS) — վաճառվածի բաղադրիչային արժեքը տող առ տող. յուրաքանչյուր ապրանքի բաղադրատոմսը, հավելումներից ընտրված լցոնումներն ու փոխարինումները և բաղադրիչների կշռված միջին գները։',
    helpGross: 'Համախառն շահույթ = եկամուտ − COGS։ Հաստատուն ծախսերը գալիս են ձեր ամսական գրառումներից և հերթափոխերի դրամարկղի (մանր կանխիկի) ծախսերից։ Զուտ շահույթ = համախառն շահույթ − բոլոր հաստատուն ծախսերը։',
    lineRevenue: 'Եկամուտ',
    lineCogs: '− Սննդի ինքնարժեք (COGS)',
    lineGross: '= Համախառն շահույթ',
    lineLabor: '− Աշխատավարձ',
    lineRent: '− Վարձակալություն',
    lineUtilities: '− Կոմունալ ծառայություններ',
    lineDrawer: '− Դրամարկղի ծախսեր',
    lineMarketing: '− Մարքեթինգ',
    lineOther: '− Այլ հաստատուն',
    lineNet: '= Զուտ շահույթ',
    breakEven: 'Անվնասության շեմ և պահուստ',
    fixedCosts: 'Հաստատուն ծախսեր / ամիս',
    revenueNeeded: 'Անհրաժեշտ եկամուտ / օր',
    coversNeeded: 'Անհրաժեշտ հյուրեր / օր',
    inventoryOnHand: 'Առկա պաշար',
    inventoryDays: '~{{days}} օր',
    cashBalance: 'Կանխիկ մնացորդ',
    cashRunway: 'Կանխիկի պահուստ',
    cashRunwayValue: '~{{months}} ամիս',
    profitableNote: 'Շահութաբեր է — կանխիկ մնացորդը աճում է, եթե շահույթը պահում եք։',
    monthlyCosts: 'Ամսական ծախսեր և կանխիկ մնացորդ',
    monthlyHint: 'Մուտքագրեք այս ամսվա հաստատուն ծախսերը։ Դրամարկղի ծախսերը (մանր կանխիկ) ավտոմատ վերցվում են հերթափոխերից։',
    cashOnHand: 'Առկա կանխիկ (֏)',
    catLabor: 'Աշխատանք / աշխատավարձեր',
    catRent: 'Վարձակալություն',
    catUtilities: 'Կոմունալ ծառայություններ',
    catMarketing: 'Մարքեթինգ',
    catOther: 'Այլ հաստատուն',
    menuProfit: 'Մենյուի շահութաբերություն (ըստ շահույթի ներդրման)',
    colProduct: 'Ապրանք',
    colType: 'Տեսակ',
    colQty: 'Քանակ',
    colProfit: 'Շահույթ',
    colMargin: 'Մարժա',
    menuMatrix: 'Մենյուի մատրիցա',
    considerRemoving: 'Դիտարկեք հանելը՝',
    star: 'Աստղ',
    workhorse: 'Աշխատասեր',
    puzzle: 'Առեղծված',
    dog: 'Թույլ',
    starHint: 'Շարունակեք առաջ մղել — մեծ ծավալ և ուժեղ մարժա։',
    workhorseHint: 'Հանրաճանաչ է, բայց մարժան բարակ է — դիտարկեք փոքր գնի բարձրացում։',
    puzzleHint: 'Լավ մարժա, բայց ցածր վաճառք — առաջ մղեք կամ վերադիրքավորեք։',
    dogHint: 'Ցածր ծավալ և ցածր մարժա — դիտարկեք հանելը։',
    popularity: 'Հանրաճանաչություն',
    margin: 'Մարժա',
    revenueByHour: 'Եկամուտ ըստ ժամի',
    revenueByWeekday: 'Եկամուտ ըստ շաբաթվա օրվա',
    belowBreakEven: '{{amount}} եկամուտից ցածր օրերը կարող են չծածկել հաստատուն ծախսերը։',
    costCogs: 'Սննդի արժեք (COGS)',
    costLabor: 'Աշխատուժ',
    costRent: 'Վարձակալություն',
    costUtilities: 'Կոմունալ',
    costDrawer: 'Դրամարկղի ծախսեր',
    costMarketing: 'Մարքեթինգ',
    costOther: 'Այլ հաստատուն',
    ledgerCheck:
      'Պահեստի մատյանի ստուգում՝ {{ledger}} ընդդեմ պատվերի տողի COGS {{cogs}} (տարբերություն {{pct}}%)։',
    ledgerWarn:
      ' Մեծ տարբերություն — հաճախ հին նվազեցումներ (օր. միավորների փոփոխությունից հետո) կամ վերադարձներ այլ ամսում։',
    ledgerOk: ' Մատյանը և պատվերի տողի COGS-ը այս ամսվա համար համընկնում են։',
    helpLedger:
      'Ստորև պահեստի մատյանի ստուգումը համեմատում է սա ֆիզիկական պաշարի նվազեցումների հետ։ Մեծ տարբերությունները սովորաբար նշանակում են հին տվյալներ կամ միավորների միգրացիա — ոչ թե սխալ COGS P&L տողում։',
    helpCogsExtra:
      'Երբ հասանելի է, օգտագործում է պատվերի փակման ժամանակ ամրագրված cogs_amd-ը· հին տողերը գնահատվում են ընթացիկ բաղադրատոմսերից։',
    helpMenuAgg: 'Մեկ տող յուրաքանչյուր ապրանքի համար՝ այս ամսվա բոլոր վճարված պատվերների տողերով։',
    helpMenuQty:
      'Քանակ — վաճառված միավորներ։ Շահույթ = տողի եկամուտ − տողի COGS (նույն տրամաբանությամբ, ինչ P&L սննդի արժեքը)։ Դասավորված ըստ շահույթի — ամենամեծ ներդրումից։',
    helpMenuMargin:
      'Մարժա = շահույթ ÷ եկամուտ այդ ապրանքի համար։ Տեսակը (Աստղ / Աշխատասեր / Առեղծված / Թույլ) բաժանում է հանրաճանաչությունն ու մարժան 50%-ով — մենյուի ճարտարագիտության քառորդներ։',
    helpMenuWine:
      'Գինին և ընտրությամբ ապրանքները օգտագործում են իրականում վաճառված չափաբաժինը (պատվերի մոդիֆիկատորներից), ոչ թե տեսական միջինը։',
    sun: 'Կիրակի',
    mon: 'Երկուշաբթի',
    tue: 'Երեքշաբթի',
    wed: 'Չորեքշաբթի',
    thu: 'Հինգշաբթի',
    fri: 'Ուրբաթ',
    sat: 'Շաբաթ',
  },
  stockIn: {
    title: 'Պաշարի մուտք',
    subtitle: 'Կառավարեք գնման պատվերները և գրանցեք բաղադրիչների առաքումները։',
    newPurchase: 'Նոր գնում',
    generateOrders: 'Ստեղծել պատվերներ',
    undoToast: 'Պատվերը նշված է որպես ուղարկված։',
    noLines: 'Ավելացրեք առնվազն մեկ բաղադրիչ՝ զրոյից մեծ քանակով։',
    duplicateIngredient: 'Յուրաքանչյուր բաղադրիչ կարող է մեկ անգամ հայտնվել մեկ առաքման մեջ։',
    noLowStock: 'Այժմ ոչ մի բաղադրիչ ցածր պաշարի շեմից ցածր չէ։',
    loadFailed: 'Բեռնումը ձախողվեց',
    createFailed: 'Չհաջողվեց ստեղծել գնման պատվերը։',
    undoTitle: 'Հետարկե՞լ գնումը։',
    undoBody: 'Սա կջնջի գրառումը և կվերականգնի պաշարը հետևյալի համար՝',
    undoLine: '{{name}}՝ −{{qty}} {{unit}}',
    undoConfirm: 'Հետարկել և վերականգնել',
    cancelTitle: 'Չեղարկե՞լ պատվերը։',
    cancelBody: 'Պատվերը կնշվի որպես չեղարկված։ Պաշարի փոփոխություններ չեն լինի։',
    cancelConfirm: 'Չեղարկել պատվերը',
    generateTitle: 'Ստեղծել պատվերներ',
    generateIntro: '{{count}} բաղադրիչ շեմից ցածր է։ Նշանակեք մատակարար և քանակ, ապա ստեղծեք նախագծային պատվերներ։',
    colIngredient: 'Բաղադրիչ',
    colInStock: 'Առկա պաշար',
    colSupplier: 'Մատակարար',
    colQtyToOrder: 'Պատվիրելի քանակ',
    thresholdHint: 'շեմ՝ {{threshold}} {{unit}}',
    supplierNone: '— չկա —',
    qtyPlaceholder: 'քանակ',
    needOne: 'Պատվերներ ստեղծելու համար առնվազն մեկ բաղադրիչին նշանակեք մատակարար և քանակ։',
    createDrafts: 'Ստեղծել {{count}} նախագծային պատվեր',
    pendingTitle: 'Սպասման պատվերներ',
    colStatus: 'Կարգավիճակ',
    colItems: 'Ապրանքներ',
    colCreated: 'Ստեղծված',
    colNote: 'Նշում',
    noSupplier: 'Մատակարար չկա',
    whatsapp: 'WhatsApp',
    whatsappTitle: 'Ուղարկել {{name}}-ին WhatsApp-ով',
    whatsappNoPhone: 'WhatsApp-ը միացնելու համար այս մատակարարին ավելացրեք հեռախոսահամար',
    receive: 'Ընդունել',
    receiveTitle: 'Հաստատել ապրանքների ստացումը — թարմացնում է պաշարը',
    cancelOrderTitle: 'Չեղարկել այս պատվերը',
    confirmDelivery: 'Հաստատել առաքումը',
    captionReceive: 'Ճշգրտեք քանակները ըստ իրականում ստացվածի, ապա հաստատեք՝ պաշարին ավելացնելու համար։',
    captionNew: 'Գրանցեք գնված բաղադրիչները։ Պաշարը և ինքնարժեքը թարմացվում են հաստատումից անմիջապես հետո։',
    footerLines: '{{count}} տող',
    footerTotal: ' · Ընդամենը {{amount}}',
    confirmReceipt: 'Հաստատել ստացումը',
    confirmPurchase: 'Հաստատել գնումը',
    supplier: 'Մատակարար',
    note: 'Նշում',
    notePlaceholder: 'Հաշիվ-ապրանքագրի համար, առաքման մանրամասներ…',
    colQtyReceived: 'Ստացված քանակ',
    colUnitCost: 'Միավորի արժեք (AMD)',
    typeIngredient: 'Մուտքագրեք բաղադրիչ…',
    noMatch: 'Համընկնող բաղադրիչ չկա',
    inStock: 'Առկա պաշար՝ {{stock}} {{unit}}',
    unitCostPlaceholder: 'Միավորի արժեք ֏',
    removeLine: 'Հեռացնել տողը',
    addIngredient: 'Ավելացնել բաղադրիչ',
    historyTitle: 'Գնումների պատմություն',
    purchaseCount: '{{count}} գնում',
    empty: 'Դեռ գնումներ չեն գրանցվել։',
    emptyRange: 'Ընտրված ժամանակահատվածում գնումներ չկան։',
    colDate: 'Ամսաթիվ',
    colTotalCost: 'Ընդհանուր արժեք',
    colAddedBy: 'Ավելացրել է',
    undoTitleRow: 'Հետարկել և վերականգնել պաշարը',
    statusDraft: 'նախագիծ',
    statusSent: 'ուղարկված',
    statusReceived: 'ստացված',
    statusCancelled: 'չեղարկված',
    csvDate: 'Ամսաթիվ',
    csvSupplier: 'Մատակարար',
    csvIngredient: 'Բաղադրիչ',
    csvQuantity: 'Քանակ',
    csvUnit: 'Միավոր',
    csvUnitCost: 'Միավորի արժեք (AMD)',
    csvLineTotal: 'Տողի գումար (AMD)',
    csvAddedBy: 'Ավելացրել է',
    csvNote: 'Նշում',
  },
  prepBatches: {
    title: 'Նախապատրաստման խմբաքանակներ',
    recalcAll: 'Վերահաշվարկել բոլոր նախապատրաստման արժեքները',
    recalcUpdated: 'Թարմացված է {{count}}՝ {{list}}',
    recalcSkipped: 'Բաց թողնված է {{count}}՝ {{list}}',
    recalcNothing: 'Թարմացնելու ոչինչ չկա։',
    recalcFailed: 'Վերահաշվարկը ձախողվեց',
    subtitle: 'Գրանցեք նախապատրաստման խմբաքանակ՝ հում բաղադրիչները հանելու, նախապատրաստված պաշարը թարմացնելու և խմբաքանակի արժեքը նախապատրաստված բաղադրիչի գնին փոխանցելու համար։',
    recalcTitle: 'Յուրաքանչյուր նախապատրաստված բաղադրիչի արժեքը սահմանել բաղադրատոմսի կազմից և ընթացիկ հում գներից',
    recalcConfirm: 'Վերահաշվարկե՞լ նախապատրաստված բաղադրիչների արժեքները ընթացիկ բաղադրատոմսերից և հում բաղադրիչների գներից։ Խմբաքանակների պատմությունը և պաշարը չեն փոխվի։',
    logPanel: 'Գրանցել նախապատրաստման խմբաքանակ',
    selectRecipe: 'Ընտրեք նախապատրաստման բաղադրատոմս…',
    recipeOption: '{{name}} (ելք՝ {{yield}} {{unit}})',
    qtyPlaceholder: 'Արտադրված քանակ',
    qtyWithUnit: 'Արտադրված քանակ ({{unit}})',
    notePlaceholder: 'Նշում (ոչ պարտադիր)',
    previewTitle: '{{qty}} {{unit}}-ի համար հանվելիք բաղադրիչներ',
    previewYield: '(բաղադրատոմսի քանակները հաշվված են {{yield}} {{unit}}-ի համար)',
    colIngredient: 'Բաղադրիչ',
    colDeduct: 'Հանել',
    colInStock: 'Առկա պաշար',
    low: 'ցածր',
    reviewConfirm: 'Ստուգել և հաստատել',
    confirm: 'Հաստատել',
    recipesLink: 'Բաղադրատոմսեր',
    historyTitle: 'Խմբաքանակների պատմություն',
    subRecipeWarning: 'Ենթաբաղադրատոմսերը չեն լուծվում — դրանց բաղադրիչները ուղղակիորեն ավելացրեք այս նախապատրաստման բաղադրատոմսին։',
    insufficient: 'Որոշ բաղադրիչների պաշարը բավարար չէ։ Պաշարը կիջեցվի մինչև 0։',
    batchCost: 'Խմբաքանակի հում արժեք՝ {{raw}} → {{unitCost}}/{{unit}} նախապատրաստված ելք',
    missingCost: 'Բացակայում է հում արժեքը՝ {{names}}',
    confirmPrompt: 'Հաստատե՞լ {{name}}-ի {{qty}} {{unit}}-ի գրանցումը։',
    success: 'Գրանցված է {{qty}} {{unit}} {{name}}',
    logFailed: 'Չհաջողվեց գրանցել խմբաքանակը',
    emptyRecipes: 'Նախապատրաստման բաղադրատոմսեր դեռ չկան։ Անցեք «Բաղադրատոմսեր» և միացրեք բաղադրատոմսը որպես նախապատրաստում։',
    empty: 'Դեռ խմբաքանակներ չեն գրանցվել։',
    colDate: 'Ամսաթիվ',
    colPrep: 'Նախապատրաստում',
    colQty: 'Արտադրված քանակ',
    colBy: 'Կատարել է',
    colNote: 'Նշում',
  },
  modifiers: {
    title: 'Հավելումներ',
    howTitle: 'Ինչպես են աշխատում հավելումները',
    addGroup: 'Ավելացնել հավելումների խումբ',
    namePlaceholder: 'Խմբի անուն (օրինակ՝ Հատիկի տեսակ)',
    min: 'Նվազագույն',
    max: 'Առավելագույն',
    submit: 'Ավելացնել խումբ',
    groupNameRequired: 'Խմբի անունը պարտադիր է։',
    subtitle: 'Ավելացրեք ընտրելի տարբերակներ ապրանքներին — սառույց, հետ տանելու, լրացուցիչ շոթ և այլն։ Յուրաքանչյուր խումբ կցեք միայն այն ապրանքներին, որտեղ այն կիրառելի է։',
    step1: 'Ստեղծեք խումբ — օրինակ՝ Պատրաստում (նվազագույնը 0, առավելագույնը 1 = ոչ պարտադիր) կամ Սպասարկում (նվազագույնը 1, առավելագույնը 1 = դրամարկղավարը պարտավոր է ընտրել)։',
    step2: 'Ավելացրեք տարբերակներ — օրինակ՝ Առանց սառույցի, Լրացուցիչ սառույց, Հետ տանելու, Տեղում։',
    footer: 'Ընտրված տարբերակները հայտնվում են տպված կտրոնում և խոհանոցի տոմսում։ Գինը = հիմնական ապրանք + տարբերակների գնային տարբերություններ։',
    optionNameRequired: 'Տարբերակի անունը պարտադիր է։',
    deleteConfirm: 'Ջնջե՞լ այս հավելումների խումբը և նրա բոլոր տարբերակները։',
    empty: 'Հավելումների խմբեր դեռ չկան։ Ստեղծեք վերևում։',
    pickRule: 'ընտրել {{rule}}',
    required: ' (պարտադիր)',
    optional: ' (ոչ պարտադիր)',
    options: 'Տարբերակներ',
    optionName: 'Տարբերակի անուն',
    deltaKind: 'Գնի փոփոխություն',
    kindFixed: '֏',
    kindPercent: '%',
    deltaPlaceholder: 'Դրամ, օրինակ՝ 1500 կամ -200',
    deltaPlaceholderPercent: 'Տոկոս, օրինակ՝ 10 կամ -10',
    deltaInvalid: 'Մուտքագրեք թիվ։ Զեղչի համար օգտագործեք մինուս։',
    addOption: 'Ավելացնել տարբերակ',
    noOptions: 'Տարբերակներ դեռ չկան։',
    colOption: 'Տարբերակ',
    colPriceDelta: 'Գնի տարբերություն',
    attached: 'Կցված ապրանքներ',
    noAttached: 'Դեռ ապրանքներ կցված չեն։',
    attachPlaceholder: '+ Կցել ապրանք…',
    removeTitle: 'Հեռացնել {{name}}',
    step3: 'Կցեք ապրանքներին — առանց կցման ապրանքները երբեք չեն ցուցադրի այդ խումբը։',
  },
  loyalty: {
    title: 'Հավատարմություն',
    subtitleDisabled: 'Միավորների պարգևներ + Apple/Google Wallet անդամության քարտեր։',
    notAvailableTitle: 'Դեռ հասանելի չէ',
    settings: 'Ծրագրի կարգավորումներ',
    enable: 'Միացնել հավատարմության ծրագիրը',
    earnRate: 'Կուտակման դրույք',
    redeemRate: 'Փոխանակման դրույք',
    saved: 'Պահպանված է։',
    subtitleEnabled: 'Կուտակեք և օգտագործեք {{pointName}}, անդամության զեղչեր և դրամապանակի քարտեր հաճախորդի համարներով։',
    notAvailableBody: 'Հավատարմության ծրագիրը ձեր սրճարանի համար միացված չէ։ Խնդրեք Orio ադմինիստրատորին միացնել այն։',
    earnHint: 'AMD ծախս՝ 1 միավոր կուտակելու համար։',
    redeemHint: 'AMD զեղչ 1 միավորի դիմաց։ Պահեք շատ ավելի ցածր, քան կուտակման դրույքը։',
    rateSummary: 'Դրույքների ամփոփում',
    hideRateSummary: 'Թաքցնել դրույքների ամփոփումը',
    saveSettings: 'Պահպանել կարգավորումները',
    notProvisioned: 'Այս սրճարանի համար հավատարմությունը տրամադրված չէ — դիմեք ադմինիստրատորին։',
    exampleTitle: 'Օրինակ ընթացիկ դրույքներով',
    exampleSpend: 'Հաճախորդը ծախսում է {{amount}} → կուտակում է {{coins}} {{pointName}} (1-ը՝ {{earnRate}} AMD-ի դիմաց)։',
    walletTitle: 'Դրամապանակի քարտի ձևավորում',
    logoText: 'Քարտի պատկերանիշի տեքստ',
    logoPlaceholder: 'Սրճարանի անուն',
    logoHint: 'Ցուցադրվում է Apple/Google Wallet քարտի վերևում։',
    passColor: 'Քարտի գույն',
    colorApply: 'Կիրառվում է նոր քարտերի վրա։ Գոյություն ունեցող քարտերը պահում են իրենց ձևավորումը։',
    saveDesign: 'Պահպանել ձևավորումը',
    colorDark: 'մուգ',
    colorBlue: 'կապույտ',
    colorGreen: 'կանաչ',
    colorRed: 'կարմիր',
    colorPurple: 'մանուշակագույն',
    colorOrange: 'նարնջագույն',
    linksTitle: 'Գրանցման հղումներ',
    newLink: '+ Նոր հղում',
    namePlaceholder: 'Անուն (օրինակ՝ VIP մակարդակ)',
    collectPoints: 'Կուտակել միավորներ',
    customNumber: 'Անհատական #',
    add: 'Ավելացնել',
    discountByCategory: 'Զեղչ ըստ մենյուի կատեգորիայի',
    collect: 'Կուտակել',
    custom: 'Անհատական',
    colName: 'Անուն',
    colDiscount: 'Զեղչ',
    colPoints: 'Միավորներ',
    colCustomNumber: 'Անհատական #',
    colLink: 'Հղում',
    colStatus: 'Կարգավիճակ',
    copyLink: 'Պատճենել հղումը',
    disableTitle: 'Սեղմեք՝ գրանցումներն անջատելու համար',
    enableTitle: 'Սեղմեք՝ նորից միացնելու համար',
    created: 'Գրանցման հղումը ստեղծված է։',
    updated: 'Հղումը թարմացված է։ Նոր գրանցումները ստանում են նոր պայմանները. գործող անդամները պահում են իրենցը։',
    duplicateName: 'Այդ անունով հղում արդեն գոյություն ունի։',
    noCategories: 'Մենյուի կատեգորիաներ դեռ չկան։',
    allCategories: 'Բոլոր կատեգորիաները',
    mixed: 'Խառը',
    membersTitle: 'Անդամներ ({{filtered}})',
    removeSelected: 'Հեռացնել ընտրվածները ({{count}})',
    addMember: '+ Ավելացնել անդամ',
    source: 'Աղբյուր',
    allSources: 'Բոլոր աղբյուրները',
    manual: 'Ձեռքով',
    linkRemoved: 'Հղումը հեռացված է',
    phoneOptional: 'Հեռախոս (ոչ պարտադիր)',
    create: 'Ստեղծել',
    enterName: 'Մուտքագրեք անդամի անունը։',
    memberCreated: 'Անդամը ստեղծված է։',
    emptyMembers: 'Անդամներ դեռ չկան։',
    emptyFilter: 'Այս աղբյուրի զտիչին համապատասխան անդամներ չկան։',
    emptyLinks: 'Հղումներ դեռ չկան։ Ստեղծեք մեկը, որպեսզի հաճախորդները կարողանան միանալ։',
    qr: 'QR',
    remove: 'Հեռացնել',
    colCustomerNumber: 'Հաճախորդի #',
    colEarnsPoints: 'Կուտակում է միավորներ',
    colWallet: 'Դրամապանակ',
    colJoined: 'Միացել է',
    qrTitle: 'Անդամի QR',
    qrBody: 'Հաճախորդի համար {{code}} — դրամապանակի քարտ չկա։ Տպեք կամ կիսվեք այս QR-ով՝ POS-ում որոնելու համար։',
    actionsAria: 'Գործողություններ',
    linkNameAria: 'Հղման անուն',
    memberNameAria: 'Անդամի անուն',
    selectAllAria: 'Ընտրել բոլոր տեսանելի անդամներին',
    selectMemberAria: 'Ընտրել {{name}}',
    customNumberTitle: 'Գրանցվողները կարող են ընտրել իրենց հաճախորդի համարը (1000+)',
    uniqueCodeFailed: 'Չհաջողվեց ստեղծել եզակի հաճախորդի համար։ Փորձեք կրկին։',
    manualMembersNote: 'Ձեռքով ավելացված անդամները ստանում են հաճախորդի համար և QR կոդ միայն — դրամապանակի քարտ չկա։',
    discountPercentAria: '{{name}} զեղչի տոկոս',
    editDiscounts: 'Խմբագրեք կատեգորիաների զեղչերը ստորև',
    cardTitleAlways: 'Քարտի վերնագիրը միշտ {{title}} է։',
    balanceShown: 'Մնացորդը ցուցադրվում է որպես {{name}}։',
  },
  loyaltyJoin: {
    pageTitle: 'Միանալ պարգևներին',
    pageTitleCafe: 'Միանալ պարգևներին — {{cafeName}}',
    unavailable: 'Գրանցումն առժամանակ անհասանելի է։',
    notConfigured: 'Հավելվածը կարգավորված չէ։',
    defaultTitle: 'Միանալ պարգևներին',
    signUp: 'Գրանցվել',
    signingUp: 'Գրանցում…',
    incompleteLink: 'Այս գրանցման հղումն անավարտ է։ Խնդրեք սրճարանից ամբողջական պարգևների հղումը։',
    loadFailed: 'Չհաջողվեց բեռնել սրճարանը։',
    cafeNotFound: 'Սրճարանը չի գտնվել։',
    notAvailable: 'Այս սրճարանի համար հավատարմությունը դեռ հասանելի չէ։',
    notOpen: 'Հավատարմության գրանցումը դեռ բաց չէ — վերադարձեք շուտով։',
    invalidLink: 'Այս գրանցման հղումը վավեր չէ կամ անջատված է։',
    loadPageFailed: 'Չհաջողվեց բեռնել գրանցման էջը։',
    enterName: 'Մուտքագրեք ձեր անունը։',
    enrollNotConfigured: 'Գրանցումը սպասարկիչում դեռ կարգավորված չէ։',
    noWalletLink: 'Դրամապանակի հղում չվերադարձվեց։ Փորձեք կրկին կամ դիմեք սրճարանին։',
    signupFailed: 'Գրանցումը ձախողվեց։',
    youGet: 'Դուք ստանում եք {{benefit}}։ ',
    earnPoints: 'Վճարելիս կուտակեք {{pointName}} — 1-ը՝ ծախսված {{earnRate}} AMD-ի դիմաց։',
    discountOnly: 'Այս անդամությունը միավորներ չի կուտակում — միայն զեղչ։',
    successTitle: 'Ավելացրեք ձեր դրամապանակին',
    customerNumber: 'Ձեր հաճախորդի համարը՝ {{code}}',
    savePass: 'Պահպանեք ստորև քարտը — այն ներառում է ձեր QR կոդը։',
    addWallet: 'Ավելացնել Apple / Google Wallet',
    nameLabel: 'Ձեր անունը',
    namePlaceholder: 'Անուն ազգանուն',
    phoneLabel: 'Հեռախոս (ոչ պարտադիր)',
    phonePlaceholder: '91 123456',
    phoneAria: 'Հեռախոսահամար առանց երկրի կոդի',
    customNumberLabel: 'Հաճախորդի համար (ոչ պարտադիր, {{min}}+)',
    customNumberPlaceholder: 'Թողեք դատարկ ավտոմատի համար, կամ օր. {{min}}',
    leadPoints: 'Թվային դրամապանակի քարտ ձեր հաճախորդի համարով։ Կուտակեք միավորներ յուրաքանչյուր այցելության ժամանակ։',
    leadDiscount: 'Թվային դրամապանակի քարտ ձեր հաճախորդի համարով և անդամի զեղչերով։',
    plus: ' գումարած ',
    pctOffCategory: '{{pct}}% զեղչ {{name}}',
    upToOff: 'Մինչև {{pct}}% զեղչ ընտրված կատեգորիաներից',
    pctOffEvery: '{{pct}}% զեղչ յուրաքանչյուր այցելության ժամանակ',
  },
  settings: {
    title: 'Կարգավորումներ',
    taxTitle: 'Հայաստանի հարկային ծառայության մուտքի տվյալներ',
    tin: 'TIN (հարկ վճարողի նույնացուցիչ)',
    tinPlaceholder: 'օրինակ՝ 08319907',
    username: 'Մուտքանուն',
    usernamePlaceholder: 'Հարկային ծառայության մուտք',
    password: 'Գաղտնաբառ',
    saved: 'Պահպանված է։',
    posPassword: 'Գաղտնաբառ',
    generate: 'Ստեղծել',
    taxIntro: 'Ապահով պահվում են ձեր հաշվում և օգտագործվում են հաշիվ-ապրանքագրեր ստանալու համար։ Դրանք տեսնել կամ փոխել կարող եք միայն դուք (սեփականատերը)։',
    activeToken: 'Հարկային ծառայության գործող նշան',
    tokenHint: 'Սա JWT-ն է, որն օգտագործվում է հարկային ծառայությանը դիմելու համար։ Այն ընդհանուր է այս հաշվով մուտք գործած բոլոր սարքերի համար։',
    posTitle: 'POS սարքի գաղտնաբառ',
    posIntro: 'Այս գաղտնաբառը մեկ անգամ մուտքագրեք նոր POS սարքում՝ այն գրանցելու համար։ Սարքը կհիշի սրճարանը և դրամարկղավարների ցանկը — դրանից հետո դրամարկղավարներին պետք է միայն իրենց PIN-ը։',
    posPlaceholder: 'Սահմանեք POS գաղտնաբառ…',
  },
  users: {
    title: 'Օգտատերեր',
    subtitle: 'Ստեղծեք վահանակի հաշիվներ այն աշխատակիցների համար, ովքեր օգնում են կառավարել բիզնեսը։',
    rolesTitle: 'Դերերի հասանելիություն',
    createTitle: 'Ստեղծել օգտատեր',
    emailPlaceholder: 'Էլեկտրոնային հասցե',
    namePlaceholder: 'Անուն ազգանուն (ոչ պարտադիր)',
    roleManagerOpt: 'Կառավարիչ',
    roleAdminOpt: 'Ադմինիստրատոր',
    roleAccountantOpt: 'Հաշվապահ',
    submit: 'Ստեղծել օգտատեր',
    emailRequired: 'Էլեկտրոնային հասցեն պարտադիր է։',
    roleAdmin: 'Ադմինիստրատոր — Վերլուծություն, Պատվերներ, Հերթափոխներ, Մենյու, Բաղադրիչներ, Բաղադրատոմսեր, Կտրոն, Հաշիվ-ապրանքագրեր',
    roleManager: 'Կառավարիչ — Պատվերներ, Հերթափոխներ, Մենյու, Բաղադրիչներ, Բաղադրատոմսեր, Կտրոն, Հաշիվ-ապրանքագրեր (առանց վերլուծության)',
    roleAccountant: 'Հաշվապահ — միայն հաշվապահական տվյալներ։ Կարող է ներբեռնել ArmSoft-ի փաթեթը։ Գործառնությունները փոխել չի կարող։',
    rolesFooter: 'Այս դերերից ոչ մեկը չի կարող մուտք գործել «Օգտատերեր», «Դրամարկղավարներ» կամ «Կարգավորումներ»։',
    credsTitle: 'Նոր օգտատիրոջ մուտքի տվյալներ',
    credsNote: 'Պատճենեք և ուղարկեք օգտատիրոջը։ Գաղտնաբառը ցուցադրվում է միայն մեկ անգամ։',
    email: 'Էլեկտրոնային հասցե',
    password: 'Գաղտնաբառ',
    emptyTitle: 'Օգտատերեր դեռ չկան',
    empty: 'Օգտատերեր դեռ չկան։ Ստեղծեք վերևում։',
    count: '{{count}} օգտատեր',
    colFullName: 'Անուն ազգանուն',
    colEmail: 'Էլեկտրոնային հասցե',
    colRole: 'Դեր',
    colCreated: 'Ստեղծված',
    resetPassword: 'Վերականգնել գաղտնաբառը',
    resetCreds: 'Նոր մուտքի տվյալներ — ուղարկեք օգտատիրոջը, ցուցադրվում է մեկ անգամ։',
    resetting: 'Վերականգնում…',
    copyEmail: 'Պատճենել էլ. փոստը',
    copyPassword: 'Պատճենել գաղտնաբառը',
    copied: 'Պատճենված',
  },
  clients: {
    title: 'Հաճախորդներ',
    subtitle: 'Ստեղծեք սրճարան/ռեստորան և դրա սեփականատիրոջ հաշիվը։',
    newTitle: 'Նոր հաճախորդ',
    cafeName: 'Սրճարանի անուն',
    cafePlaceholder: 'Demo Cafe',
    ownerEmail: 'Սեփականատիրոջ էլեկտրոնային հասցե',
    ownerEmailPlaceholder: 'owner@cafe.com',
    ownerName: 'Սեփականատիրոջ անուն',
    ownerNamePlaceholder: 'Անուն ազգանուն',
    submit: 'Ստեղծել հաճախորդ',
    required: 'Սրճարանի անունը և սեփականատիրոջ էլեկտրոնային հասցեն պարտադիր են։',
    credsTitle: '{{name}} — սեփականատիրոջ մուտքի տվյալներ',
    credsNote: 'Պատճենեք և ուղարկեք սեփականատիրոջը։ Ցուցադրվում են միայն մեկ անգամ։',
    copyCreds: 'Պատճենել մուտքի տվյալները',
    allClients: 'Բոլոր հաճախորդները',
    emptyTitle: 'Հաճախորդներ դեռ չկան',
    empty: 'Ստեղծեք ձեր առաջին սրճարանը վերևում։',
    colCafe: 'Սրճարան',
    colOwnerEmail: 'Սեփականատիրոջ էլեկտրոնային հասցե',
    colLoyalty: 'Հավատարմություն',
    colTableService: 'Սեղանի սպասարկում',
    colBookings: 'Ամրագրումներ',
    colWalletPasses: 'Դրամապանակի քարտեր',
    colActive: 'Ակտիվ',
    colCreated: 'Ստեղծված',
    rename: 'Վերանվանել',
    rowActions: 'Գործողություններ',
    newPassword: 'Նոր գաղտնաբառ',
    resetConfirm: 'Վերականգնե՞լ {{name}}-ի սեփականատիրոջ գաղտնաբառը։ Գործող գաղտնաբառն անմիջապես կդադարի գործել։',
    resetYes: 'Այո, վերականգնել',
    resetFailed: 'Վերականգնումը ձախողվեց',
    statsActiveToday: 'Այսօր վաճառում է',
    statsActiveSub: '{{selling}} / {{total}} ակտիվ',
    statsOrdersToday: 'Այսօրվա պատվերներ',
    statsQuiet: 'Լուռ սրճարաններ',
    statsQuietSub: '3 օր պատվեր չկա',
    statsForce30: 'Հարկադիր փակված, 30 օր',
    statsRevenue30: 'Հասույթ, 30 օր',
    colLastOrder: 'Վերջին պատվեր',
    colOrders30: 'Պատվերներ, 30 օր',
    colRegisters: 'Դրամարկղներ',
    openStats: 'Բացել օգտագործումը',
    freshToday: 'Այսօր',
    freshYesterday: 'Երեկ',
    freshDays: '{{n}} օր առաջ',
    freshNever: 'Պատվեր չկա',
    versionNone: 'Դեռ չկա',
    versionCount: '{{version}} × {{n}}',
    sectionActivity: 'Ակտիվություն',
    sectionHealth: 'Վիճակ',
    sectionUsage: 'Օգտագործում',
    sectionRegisters: 'Դրամարկղներ',
    ordersToday: 'Այսօրվա պատվերներ',
    orders7: 'Պատվերներ, 7 օր',
    orders30: 'Պատվերներ, 30 օր',
    openShifts: 'Բաց հերթափոխներ',
    lastShift: 'Վերջին հերթափոխի բացում',
    lastSignIn: 'Վերջին մուտք',
    force30: 'Հարկադիր փակված, 30 օր',
    forceSystem: 'Վճարված, համակարգի սխալ',
    forceMistake: 'Սխալ',
    forceFree: 'Անվճար',
    forceOther: 'Այլ պատճառ',
    paidNoFiscal: 'Վճարված, առանց ՀԴՄ կտրոնի',
    paidNoPayment: 'Վճարված, առանց վճարման տողի',
    diagnostics30: 'Ախտորոշումներ, 30 օր',
    cashiers: 'Գանձապահներ',
    dashboardUsers: 'Վահանակի օգտատերեր',
    products: 'Ապրանքներ ցանկում',
    categories: 'Կատեգորիաներ',
    ingredients: 'Բաղադրիչներ',
    recipes: 'Բաղադրատոմսեր',
    loyaltyMembers: 'Հավատարմության անդամներ',
    bookingsMonth: 'Ամրագրումներ այս ամիս',
    invoicesMonth: 'Հաշիվ-ապրանքագրեր այս ամիս',
    revenue30: 'Հասույթ, 30 օր',
    registersEmpty: 'Դրամարկղ դեռ չի գրանցվել։ Կհայտնվի POS-ի հաջորդ թարմացումից հետո։',
    colVersion: 'Տարբերակ',
    colPlatform: 'Հարթակ',
    colLastSeen: 'Վերջին կապ',
    colPending: 'Սպասում է ուղարկման',
    colLastGap: 'Վերջին լռություն',
    colOffline30: 'Անցանց, 30 օր',
    seenJustNow: 'Հենց նոր',
    seenMinutes: '{{n}} ր առաջ',
    seenHours: '{{n}} ժ առաջ',
    seenDays: '{{n}} օր առաջ',
    minutesShort: '{{n}} ր',
    hoursShort: '{{n}} ժ',
    hoursMinutes: '{{hours}} ժ {{minutes}} ր',
    platformMacos: 'Mac',
    platformWindows: 'Windows',
    platformWeb: 'Դիտարկիչ',
    platformDesktop: 'Համակարգիչ',
    never: 'Երբեք',
  },
  settingsPage: {},
  receipt: {
    popupBlocked: 'Ելնող պատուհանը արգելափակված է։ Թույլատրեք ելնող պատուհանները՝ կտրոնը տպելու համար։',
  },
  wasteLog: {
    newEntry: 'Նոր գրառում',
    newCaption: 'Պաշարը նվազում է անմիջապես։',
    compRecipient: 'Անվճար ստացող',
    commentRequired: '«Այլ»-ի համար ավելացրեք մեկնաբանություն։',
    commentPlaceholder: 'Մեկնաբանությունը պարտադիր է',
    selectRecipient: 'Ընտրել անուն…',
    recipientRequired: 'Ընտրեք, թե ում համար է այս աշխատակցի սնունդը։',
    cancelEntry: 'Չեղարկել գրառումը',
    editTitle: 'Խմբագրել թափոնը',
    quantity: 'Քանակ',
    reason: 'Պատճառ',
    note: 'Նշում',
    cancelTitle: 'Չեղարկե՞լ այս թափոնի գրառումը։',
    cancelMessage: 'Վերականգնել {{qty}} {{unit}} {{name}} պաշարին։ Սա չի կարող հետարկվել։',
    cancelled: 'Չեղարկված',
    cancelling: 'Չեղարկում…',
  },
  invoices: {
    title: 'Հաշիվ-ապրանքագրեր',
    subtitle: 'Մատակարարների հարկային հաշիվ-ապրանքագրեր Հարկային ծառայությունից։ Ստուգեք, դասակարգեք և հաստատեք դրանք ներքին հաշվառման համար։',
    connecting: 'Միացում…',
    loadingCount: 'Բեռնում… {{count}}',
    tokenMissing: 'Հարկային ծառայության մուտքի տվյալները սահմանված չեն — ավելացրեք դրանք «Կարգավորումներ» բաժնում։',
    invoiceCount: '{{count}} հաշիվ-ապրանքագիր',
    total: 'Ընդամենը {{amount}}',
    supplierSummary: 'Մատակարարների ամփոփում →',
    supplier: 'Մատակարար',
    supplierTin: 'Մատակարարի ՀՎՀՀ',
    serial: 'Սերիական համար',
    category: 'Կատեգորիա',
    include: 'Ներառել',
    exclude: 'Բացառել',
    selectAll: 'Ընտրել բոլորը',
    clear: 'Մաքրել',
    minTotal: 'Նվազագույն գումար ֏',
    reset: 'Վերակայել',
    resetFilters: 'Վերակայել զտիչները',
    taxStatusAll: 'Հարկային կարգավիճակ՝ բոլորը',
    taxIssued: 'Թողարկված',
    taxApproved: 'Հաստատված',
    internalAll: 'Ներքին՝ բոլորը',
    pending: 'Սպասման մեջ',
    approved: 'Հաստատված',
    reverted: 'Հետարկված',
    approvedByAll: 'Հաստատել է՝ ցանկացածը',
    uncategorised: 'Առանց կատեգորիայի',
    review: 'Ստուգել',
    revert: 'Հետարկել',
    revertConfirm: 'Հետարկե՞լ։',
    noMatchTitle: 'Այս զտիչներին համապատասխան հաշիվ-ապրանքագրեր չկան',
    noMatchText: 'Թուլացրեք զտիչը կամ վերակայեք՝ այս ժամանակահատվածի ամեն ինչը տեսնելու համար։',
    emptyTitle: 'Այս ժամանակահատվածում հաշիվ-ապրանքագրեր չկան',
    emptyText: 'Ընտրեք ավելի լայն ժամանակահատված, կամ ստուգեք, որ «Կարգավորումներ» բաժնի հարկային տվյալները դեռ վավեր են։',
    reviewTitle: 'Ստուգել հաշիվ-ապրանքագիրը',
    approveHint: 'Ներքին հաստատումը թարմացնում է բաղադրիչների պաշարը։ Հարկային ծառայության կարգավիճակը չի փոխվում։',
    colNum: '#',
    colSerial: 'Հերթական համար',
    colSupplier: 'Մատակարար',
    colCategory: 'Կատեգորիա',
    colDate: 'Ամսաթիվ',
    colTotal: 'Ընդամենը',
    colTaxStatus: 'Հարկային կարգավիճակ',
    colInternal: 'Ներքին',
    colApprovedBy: 'Հաստատել է',
    loadingGoods: 'Ապրանքների բեռնում…',
    colGoodsName: 'Ապրանքի անուն (հաշիվ-ապրանքագրից)',
    colInvoiceQty: 'Հաշիվ-ապրանքագրի քանակ',
    colInvoicePrice: 'Հաշիվ-ապրանքագրի գին',
    colRecordAs: 'Գրանցել որպես',
    colUnit: 'Միավոր',
    colPrice: 'Գին',
    colLinkIngredient: 'Կապել բաղադրիչի հետ',
    existing: 'Գոյություն ունեցող',
    createNew: 'Ստեղծել նոր',
    selectIngredient: '— ընտրել բաղադրիչ —',
    ingredientName: 'Բաղադրիչի անուն',
    addIngredient: '+ Ավելացնել բաղադրիչ',
    noLineItems: 'Առանձին տողեր չկան — հաստատեք հաշիվ-ապրանքագրի մակարդակով։',
    alreadyApproved: 'Այս հաշիվ-ապրանքագիրն արդեն {{status}} է — լրացուցիչ գործողություն պետք չէ։',
    approveInternal: 'Հաստատել ներքին հաշվառմամբ',
    confirmPrompt: 'Սա կգրանցի պաշարի առաքումը և չի կարող հետարկվել։ Հաստատե՞լ։',
    approvalNote: 'Հաստատման նշում (ոչ պարտադիր)',
    yesApprove: 'Այո, հաստատել',
    approvedMsg: 'Հաստատված է։',
    csvSupplierTin: 'Մատակարարի ՀՎՀՀ',
    csvTotalAmd: 'Ընդամենը (AMD)',
    csvInternalStatus: 'Ներքին կարգավիճակ',
    csvApprovedAt: 'Հաստատման ժամ',
    revertedBy: 'Հետարկել է {{name}}',
    metaNote: 'Նշում',
    metaTotal: 'Ընդամենը',
    metaVat: 'ԱԱՀ',
    metaTax: 'Հարկ',
    delivery: 'Առաքում',
    authPerson: 'Լիազորված',
    shipFrom: 'Ուղարկող',
    shipTo: 'Ստացող',
    colTrack: 'Հաշվառել',
    trackTitle: 'Հաշվառել այս ապրանքը պաշարում',
    useSingle: 'Մեկ բաղադրիչ',
    splitAcross: 'Բաժանել բաղադրիչների միջև',
    splitQty: 'Բաժանված քանակ՝ {{sum}} / {{qty}} հաշիվ-ապրանքագրում',
    lastPrice: 'Վերջին',
    ingredientCount: '{{count}} բաղադրիչ',
    qtyPlaceholder: 'Քանակ',
    splitIngredient: '— բաղադրիչ —',
    splitNew: 'Նոր',
    newIngredientName: 'Նոր բաղադրիչի անուն',
    removeSplit: 'Հեռացնել',
    trackRequired: 'Բոլոր հաշվառվող տողերը պետք է կապված լինեն բաղադրիչի հետ (կամ բաց թողնված)',
    approvalNotePlaceholder: 'օր. մասնակի առաքում, գնի ստուգում…',
    credentialsMissing: 'Հարկային տվյալները կարգավորված չեն։ Ավելացրեք «Կարգավորումներ» բաժնում։',
    taxSessionActive:
      'Հարկային ծառայության սխալ 0032. նախորդ աշխատաշրջանը դեռ ակտիվ է։ Սպասեք մի քանի րոպե, ապա թարմացրեք էջը։',
  },
  purchases: {
    title: 'Գնումներ',
    subtitle: 'Հաստատված էլեկտրոնային հաշիվ-ապրանքագրերի ծախսը ըստ մատակարարի կատեգորիայի։ Կատեգորիաները նշանակեք «Մատակարարներ» կամ «Հաշիվ-ապրանքագրեր» բաժնում։',
    loadFailed: 'Չհաջողվեց բեռնել գնումները',
    couldntLoad: 'Չհաջողվեց բեռնել գնումները',
    totalSpend: 'Ընդհանուր ծախս',
    approvedInvoices: 'Հաստատված հաշիվ-ապրանքագրեր',
    suppliers: 'Մատակարարներ',
    chartTitle: 'Ամսական ծախս ըստ կատեգորիայի',
    nothingToChart: 'Գծապատկերելու ոչինչ չկա',
    bySupplier: 'Ծախս ըստ մատակարարի',
    noSuppliers: 'Մատակարարներ դեռ չկան',
    colInvoices: 'Հաշիվ-ապրանքագրեր',
    colSpend: 'Ծախս',
    colShare: 'Մասնաբաժին',
    uncategorized: 'Առանց կատեգորիայի',
    emptyPeriod: 'Այս ժամանակահատվածում հաստատված հաշիվ-ապրանքագրեր չկան։',
    openSummary: 'Բացել գնումների ամփոփումը',
  },
  supplierDetail: {
    viewInvoices: 'Դիտել հաշիվ-ապրանքագրերը',
    loadFailed: 'Չհաջողվեց բեռնել մատակարարի գնումները',
    totalSpend: 'Ընդհանուր ծախս',
    approvedInvoices: 'Հաստատված հաշիվ-ապրանքագրեր',
    itemsSupplied: 'Մատակարարված ապրանքներ',
    empty: 'Ընտրված ժամանակահատվածում այս մատակարարից հաստատված հաշիվ-ապրանքագրեր չկան։',
    colItem: 'Ապրանք',
    colQuantity: 'Քանակ',
    colInvoices: 'Հաշիվ-ապրանքագրեր',
    colAvgPrice: 'Միջին գին',
    colLastPrice: 'Վերջին գին',
    colTrend: 'Միտում',
    colSpend: 'Ծախս',
    colShare: 'Մասնաբաժին',
    untracked: 'չհաշվառված',
    tinPrefix: 'TIN {{tin}}',
  },
  stockCount: {
    revertModalTitle: 'Հետարկել պաշարի հաշվարկը',
    ingredient: 'Բաղադրիչ',
    countDate: 'Հաշվարկի ամսաթիվ',
    countDelta: 'Հաշվարկի տարբերություն',
    currentStock: 'Ընթացիկ պաշար',
    afterRevert: 'Հետարկումից հետո',
    reasonOptional: 'Պատճառ (ոչ պարտադիր)',
    reasonPlaceholder: 'օրինակ՝ սխալ քանակ է մուտքագրվել',
    confirmRevert: 'Հետարկել հաշվարկը',
    revertModalBody: 'Հետարկում է այս հաշվարկի ազդեցությունը ընթացիկ պաշարի վրա (հետ է շրջվում {{delta}} {{unit}})։ Բնօրինակը մնում է պատմության մեջ, բայց բացառվում է կորստի ցուցանիշներից։',
  },
  cashiers: {
    addPanel: 'Ավելացնել դրամարկղավար',
    hdmPlaceholder: 'HDM համար',
    hdmCol: 'HDM համար',
    hdmShort: 'HDM',
    username: 'Մուտքանուն',
    pin: 'PIN',
    newPinPlaceholder: 'նոր PIN',
    colUsername: 'Մուտքանուն',
    colName: 'Անուն',
    colLastSeen: 'Վերջին մուտք',
    deleteConfirm: 'Ջնջե՞լ այս դրամարկղավարին։ Սա չի կարող հետարկվել։',
    pinInvalid: 'PIN-ը պետք է լինի ճիշտ 4 նիշ։',
    usernameRequired: 'Մուտքանունը պարտադիր է։',
    empty: 'Դրամարկղավարներ դեռ չկան։',
    resetPin: 'Վերականգնել PIN-ը',
  },
  menu: {
    noClient: 'Այս հաշվի համար հաճախորդի համատեքստ չկա։',
    categoryNameRequired: 'Կատեգորիայի անունը պարտադիր է։',
    hdmDeptInvalid: 'HDM բաժինը պետք է լինի ամբողջ թիվ ≥ 1։',
    deleteCategoryConfirm: 'Ջնջե՞լ այս կատեգորիան։ Դրա ապրանքները կկորցնեն կատեգորիան։',
    productRequired: 'Անունը, կատեգորիան և գինը պարտադիր են։',
    importNoRows: 'Վավեր տողեր չեն գտնվել (յուրաքանչյուրին պետք են անուն, կատեգորիա HDM բաժնով և գին)։',
    imported: 'Ներմուծված է {{count}} ապրանք։',
    namePlaceholder: 'Անուն',
    sortPlaceholder: 'Դասավորություն',
    hdmPlaceholder: 'HDM բաժին *',
    hdmTitle: 'HDM ֆիսկալ բաժնի նույնացուցիչ (պետք է համընկնի սարքի հետ)',
    printKitchen: 'Տպել խոհանոց',
    colName: 'Անուն',
    colOrder: 'Կարգ',
    colHdm: 'HDM բաժին',
    colKitchen: 'Խոհանոց',
    colRegister: 'Դրամարկղ',
    hideFromRegister: 'Թաքցնել դրամարկղից',
    showOnRegister: 'Ցույց տալ դրամարկղում',
    confirmHideTitle: 'Թաքցնե՞լ {{name}}-ը դրամարկղից',
    confirmHideBody: 'Այն կանհետանա POS դրամարկղից և որոնումից։ Կատեգորիան կմնա մենյուում։',
    confirmShowTitle: 'Ցույց տա՞լ {{name}}-ը դրամարկղում',
    confirmShowBody: 'Այն նորից կհայտնվի POS դրամարկղում։',
    noCategories: 'Կատեգորիաներ դեռ չկան։ Ավելացրեք վերևում։',
    categoryPlaceholder: 'Կատեգորիա…',
    pricePlaceholder: 'Գին',
    unitPlaceholder: 'Միավոր',
    adgPlaceholder: 'ADG կոդ',
    codePlaceholder: 'Կոդ',
    noRecipe: 'Բաղադրատոմս չկա',
    colProduct: 'Ապրանք',
    colCategory: 'Կատեգորիա',
    colPrice: 'Գին',
    colUnit: 'Միավոր',
    colAdg: 'ADG',
    colRecipe: 'Բաղադրատոմս',
    colCost: 'Ինքնարժեք',
    colStatus: 'Կարգավիճակ',
    noProducts: 'Ապրանքներ դեռ չկան։ Նախ ավելացրեք կատեգորիաներ, ապա ապրանքներ։',
    noSearchMatch: '«{{query}}»-ին համապատասխան ապրանքներ չկան։',
    emptyCategory: 'Այս կատեգորիայում ապրանքներ չկան։',
    importHint: 'Սյուներ՝ name, category, price, unit, adg_code, code',
    deptColorTitle: 'POS ներդիրի գույն՝ բաժին {{id}}',
  },
  ingredients: {
    exportCsv: 'Արտահանել CSV',
    copy: 'Կրկնօրինակել',
    noClient: 'Հաճախորդի համատեքստ չկա։',
    nameRequired: 'Անունը պարտադիր է։',
    invalidNumber: 'Մուտքագրեք վավեր թիվ։',
    invalidNonNegative: 'Մուտքագրեք վավեր ոչ բացասական թիվ։',
    invalidDelta: 'Մուտքագրեք ոչ զրոյական փոփոխություն (բացասական՝ թափոնի համար)։',
    namePlaceholder: 'Անուն',
    lowStockPlaceholder: 'Ցածր պաշարի ծանուցում',
    costPlaceholder: 'Արժեք (AMD)',
    openingStockPlaceholder: 'Սկզբնական պաշար',
    colReorder: 'Պատվիրելի քանակ',
    colValue: 'Արժեք',
    prep: 'Նախապատրաստում',
    changeUnit: 'Փոխել միավորը',
    historyTitle: 'Պատմություն — {{name}}',
    openInvoice: 'Բացել հաշիվ-ապրանքագիրը',
    invoiceMissing: 'Այդ հաշիվ-ապրանքագիրը այլևս չկա։',
    suppliers: 'Մատակարարներ՝',
    noSuppliers: 'Գրանցված չէ',
    noTx: 'Գործարքներ դեռ չկան։',
    goToStockIn: 'Անցնել պաշարի մուտք →',
    markActive: 'Նշել որպես ակտիվ',
    markInactive: 'Նշել որպես անգործուն',
    viewHistory: 'Դիտել պատմությունը',
    lowStockBanner: '{{count}} բաղադրիչ շեմից ցածր է՝',
    moreCount: ' +ևս {{count}}',
    set: 'Սահմանել',
    newValuePlaceholder: 'նոր արժեք',
    adjustQtyPlaceholder: '±քանակ',
    notePlaceholder: 'նշում',
    ok: 'OK',
    adjustTitle: 'Ճշգրտում (թափոն / ուղղում)',
    prepManaged: 'Կառավարվում է նախապատրաստման խմբաքանակներով',
    prepManagedHint: 'Կառավարվում է նախապատրաստման խմբաքանակներով — խմբագրեք որպես ադմին/սեփականատեր',
    csvHint:
      'Սյունակներ՝ name, unit, stock, low_stock_threshold, cost_price (վերնագրի տողը պարտադիր չէ)',
    deleteTitle: 'Ջնջե՞լ բաղադրիչը։',
    deleteBody: 'Ջնջե՞լ {{name}}-ը։ Սա չի կարող հետարկվել։',
    checking: 'Ստուգում…',
    cannotDeleteTitle: 'Չի կարելի ջնջել «{{name}}»-ը',
    cannotDeleteBody:
      'Այս բաղադրիչը դեռ օգտագործվում է հետևյալ տեղերում։ Ջնջելուց առաջ հանեք այն դրանցից։',
    changeUnitTitle: 'Փոխել միավորը — {{name}}',
    newUnit: 'Նոր միավոր',
    conversionLabel: 'Փոխակերպում — 1 {{newUnit}} = քանի՞ {{oldUnit}}։',
    conversionHint: 'դրեք 1՝ միավորը պարզ վերանվանելու համար առանց վերահաշվարկի',
    previewChanges: 'Փոփոխությունների նախադիտում',
    field: 'Դաշտ',
    current: 'Ներկա',
    newCol: '→ Նոր',
    costPriceField: 'Արժեք',
    recipeLine: 'Բաղադրատոմս՝ {{name}}',
    choiceLine: 'Ընտրություն՝ {{name}}',
    ledgerRepairNote:
      'Միայն մատյանի վերանորոգում — պաշարը և բաղադրատոմսերը մնում են նույնը։ Մեծ հին գործարքների քանակները (մլ մասշտաբ, ≥ ratio ÷ 4) բաժանվում են {{ratio}}-ի վրա. փոքր տողերը, որոնք արդեն {{unit}} են (օր. վերջին +20 համալրումներ, −1 վաճառքներ), չեն փոխվում։',
    convertNote:
      'Պաշարը, բաղադրատոմսերը, արժեքը և պահեստի գործարքների ամբողջ պատմությունը փոխակերպվում են այս գործակցով։ Օգտագործեք մատյանի վերանորոգում (նույն միավոր + գործակից), եթե միավորը արդեն փոխել եք, բայց սպառման գումարները դեռ սխալ են։',
    positiveRatio: 'Մուտքագրեք դրական փոխակերպման գործակից։',
    confirmApply: 'Սա կթարմացնի վերևի բոլոր արժեքները։ Համոզվա՞ծ եք։',
    yesApply: 'Այո, կիրառել',
    renameTo: 'Վերանվանել «{{unit}}»',
    repairLedgerBtn: 'Վերանորոգել մատյանը ({{unit}})',
    convertTo: 'Փոխակերպել {{unit}}',
    colTime: 'Ժամանակ',
    colType: 'Տեսակ',
    colDelta: 'Փոփոխություն',
    colReference: 'Հղում',
    colNote: 'Նշում',
    historyPageTotal: '{{total}} ընդամենը',
    unitChangeFailed: 'Միավորի փոփոխությունը ձախողվեց',
    noValidRows: 'Վավեր տողեր չեն գտնվել։',
    imported: 'Ներմուծվել է {{count}} բաղադրիչ։',
    inStockSuffix: '{{stock}} պահեստում',
    blockRecipe: 'Բաղադրատոմս՝ «{{name}}»',
    blockSubstitute: 'Փոխարինման տարբերակ բաղադրատոմսում՝ «{{name}}»',
    blockPoItems: '{{count}} գնման պատվերի տող',
    csvName: 'Անուն',
    csvUnit: 'Միավոր',
    csvStock: 'Պաշար',
    csvLowStock: 'Ցածր պաշարի շեմ',
    csvReorder: 'Պատվիրելի քանակ',
    csvCost: 'Արժեք (AMD)',
    csvValue: 'Արժեք (AMD)',
    csvActive: 'Ակտիվ',
    csvYes: 'այո',
    csvNo: 'ոչ',
  },
  recipes: {
    cardNameRequired: 'Քարտի անունը պարտադիր է։',
    failed: 'Ձախողվեց',
    deleteConfirm: 'Ջնջե՞լ «{{name}}» բաղադրատոմսը։ Սա չի կարող հետարկվել։',
    saveName: 'Պահպանել անունը',
    newTitle: 'Նոր բաղադրատոմս',
    newCaption: 'Տվեք անուն, ապա ավելացրեք բաղադրիչներ խմբագրիչում։',
    name: 'Անուն',
    batchYield: 'Խմբաքանակի ելք',
    unit: 'Միավոր',
    prepRecipe: 'Նախապատրաստման բաղադրատոմս',
    prepHint: 'պատրաստվում է խմբաքանակներով և պահվում է որպես բաղադրիչ',
    yieldPlaceholder: 'օր. 1.5',
    unitPlaceholder: 'Միավոր…',
    noMatch: '«{{query}}»-ին համապատասխան բաղադրատոմսեր չկան։',
    noMatchTitle: 'Բաղադրատոմսեր դեռ չկան',
    noMatchText: 'Ստեղծեք մեկը՝ յուրաքանչյուր վաճառքից պաշար հաշվելու համար։',
    rename: 'Վերանվանել',
    delete: 'Ջնջել',
    prep: 'Նախապատրաստում',
    back: 'Հետ',
    selectTitle: 'Ընտրեք բաղադրատոմս',
    soldDirectly: '· վաճառվում է ուղղակիորեն',
    ingredientsTitle: 'Բաղադրիչներ',
    emptyTitle: 'Բաղադրիչներ դեռ չկան',
    emptyText: 'Ավելացրեք առաջին տողը ստորև։ Պաշարը հանվում է այս տողերից յուրաքանչյուր վաճառքի ժամանակ։',
    choiceTitle: 'Ընտրության խումբ',
    addChoice: 'Ավելացնել ընտրության խումբ',
    pickOne: 'Ընտրեք մեկը',
    choiceMode: 'Ինչպես ավելացնել ընտրությունները',
    choiceModeSeparate: 'Առանձին տողեր',
    choiceModeCombine: 'Այս ապրանքի վրա',
    choiceModeSeparateHint: 'Յուրաքանչյուր ընտրություն առանձին տող է — գինու բաժակ, շիշ։',
    choiceModeCombineHint: 'Ընտրությունները մնում են այս ապրանքի վրա — պանրի ափսե։',
    choiceMin: 'Նվազ.',
    choiceMax: 'Առավ.',
    choiceMaxNone: 'Անսահման',
    yield: 'Ելք',
    substitutePlaceholder: 'Փոխարինող բաղադրիչ…',
    pricePlus: '+ գին ֏',
    deleteRecipe: 'Ջնջել բաղադրատոմսը',
    editSubstitute: 'Խմբագրել փոխարինողը',
    removeSubstitute: 'Հեռացնել փոխարինողը',
    editLine: 'Խմբագրել տողը',
    qty: 'Քանակ',
    choiceHint: 'Դրամարկղավարը POS-ում ընտրում է այս բաղադրիչներից։ Առանձին տողեր = գինի։ Այս ապրանքի վրա = պանրի ափսե։',
    editDeduction: 'Խմբագրել հանվող քանակը',
    removeOption: 'Հեռացնել տարբերակը',
    ingredientPlaceholder: 'Բաղադրիչ…',
    searchIngredient: 'Որոնել բաղադրիչ…',
    ingredientNoMatch: 'Բաղադրիչ չի գտնվել',
    qtyPerBatch: 'Քանակ խմբաքանակում',
    makePrep: 'Դարձնել նախապատրաստման բաղադրատոմս',
    saveForSubstitutes: 'Պահպանեք՝ փոխարինողները կառավարելու համար',
    deleteGroup: 'Ջնջել խումբը',
    noOptions: 'Տարբերակներ դեռ չկան։',
    addOption: 'Ավելացնել տարբերակ',
    yields: 'Ելք',
    linkedAuto: 'կապված բաղադրիչը կառավարվում է ավտոմատ',
    autosaved: 'Պահպանված է',
  },
  bookings: {
    prevMonth: 'Նախորդ ամիս',
    nextMonth: 'Հաջորդ ամիս',
    notePlaceholder: 'Ուշ ժամանում, ալերգիաներ, հատուկ խնդրանքներ…',
    couldntLoad: 'Չհաջողվեց բեռնել ամրագրումների վերլուծությունը',
  },
  rooms: {
    pricePlaceholder: 'AMD / գիշեր',
  },
  suppliers: {
    openSummary: 'Բացել գնումների ամփոփումը',
    phonePlaceholder: '+374 XX XXX XXX',
  },
  staffComps: {
    couldntLoad: 'Չհաջողվեց բեռնել անձնակազմի անվճարները',
  },
  customerDisplay: {
    joinPlaceholder: 'https://yoursite.com/join/…',
  },
  managers: {
    title: 'Մենեջերներ',
    subtitle: 'Ստեղծեք վահանակի հաշիվներ այն աշխատակիցների համար, ովքեր կառավարում են գործառնությունները, բայց սեփականատեր չեն։',
    accessTitle: 'Մենեջերի հասանելիություն',
    canAccess: 'Հասանելի է՝',
    canAccessList: 'Պատվերներ, Հերթափոխներ, Մենյու, Բաղադրիչներ, Տեխքարտեր, Կտրոն',
    cannotAccess: 'Հասանելի չէ՝',
    cannotAccessList: 'Վերլուծություն (Վահանակ, Վաճառք, Մենյու/Անձնակազմ/Պաշար), Մենեջերներ, Դրամարկղավարներ',
    signInNote: 'Մենեջերները մուտք են գործում նույն վահանակի հասցեով՝ էլ. փոստով և ժամանակավոր գաղտնաբառով, որը դուք փոխանցում եք նրանց։',
    createTitle: 'Ստեղծել մենեջեր',
    emailPlaceholder: 'Էլ. հասցե',
    namePlaceholder: 'Անուն ազգանուն (ոչ պարտադիր)',
    creating: 'Ստեղծում…',
    create: 'Ստեղծել մենեջեր',
    credsTitle: 'Մենեջերի տվյալներ',
    credsNote: 'Պատճենեք և ուղարկեք մենեջերին։ Գաղտնաբառը ցուցադրվում է միայն մեկ անգամ։',
    email: 'Էլ. փոստ',
    password: 'Գաղտնաբառ',
    copy: 'Պատճենել',
    copied: 'Պատճենված է',
    emptyTitle: 'Մենեջերներ դեռ չկան',
    count: '{{count}} մենեջեր',
    empty: 'Մենեջերներ դեռ չկան։ Ստեղծեք վերևում։',
    colName: 'Անուն ազգանուն',
    colEmail: 'Էլ. փոստ',
    colPos: 'POS հասանելիություն',
    colCreated: 'Ստեղծվել է',
    pinPlaceholder: 'PIN (դատարկ՝ ավտոմատ)',
    cashierNo: 'Դրամարկղավարի №',
    save: 'Պահել',
    pinSet: 'PIN-ը դրված է',
    noPos: 'POS հասանելիություն չկա',
    changePin: 'Փոխել PIN-ը',
    setPin: 'Դնել PIN',
    newPin: 'Նոր PIN՝ {{pin}} — ասեք մենեջերին',
    loading: 'Բեռնում…',
  },
  books: {
    title: 'Հաշվապահական տվյալներ',
    subtitle: 'Օրական թվեր ArmSoft-ի համար։ Սա հաշվապահական գրքույկ չէ։',
    download: 'Ներբեռնել փաթեթը',
    codes: 'ArmSoft-ի կոդեր',
    codesTitle: 'ArmSoft-ի հաշիվների կոդեր',
    codesHint:
      'Այս կոդերը գրվում են արտահանված յուրաքանչյուր տողում, որպեսզի ֆայլը համընկնի ArmSoft-ի հաշվային պլանին։ Թողեք դատարկ, եթե համապատասխանեցնում եք ArmSoft-ում։',
    cashDesk: 'Դրամարկղ',
    cardAccount: 'Քարտ / էքվայրինգ',
    vatIncome: 'ԱԱՀ-ով հարկվող եկամուտ',
    exemptIncome: 'ԱԱՀ-ից ազատված եկամուտ',
    turnoverIncome: 'Շրջանառության հարկի եկամուտ',
    purchaseAccount: 'Գնումներ',
    saved: 'Կոդերը պահված են։',
    saveFailed: 'Կոդերը պահել չհաջողվեց։',
    loadFailed: 'Տվյալները բեռնել չհաջողվեց։',
    empty: 'Այս ժամանակահատվածում տվյալ չկա։',
    paid: 'Վճարված վաճառք',
    cash: 'Կանխիկ',
    card: 'Քարտ',
    missingFiscal: 'Առանց ՀԴՄ կտրոնի',
    fiscalOk: 'Այս ժամանակահատվածի բոլոր վճարված պատվերներն ունեն ՀԴՄ կտրոն։',
    fiscalGap:
      '{{count}} վճարված պատվեր ՀԴՄ կտրոն չունի ({{amount}})։ Ներմուծելուց առաջ պարզեք այդ տարբերությունը։',
    day: 'Ամսաթիվ',
    orders: 'Պատվերներ',
    gross: 'Ընդամենը',
    tips: 'Թեյավճար',
    discounts: 'Զեղչեր',
    cogs: 'Սննդի ինքնարժեք',
    fiscalReceipts: 'ՀԴՄ կտրոններ',
    tax: 'Հարկ',
    returns: 'Վերադարձ',
    comps: 'Անվճար',
    voids: 'Չեղարկումներ',
    purchases: 'Գնումներ',
    stock: 'Մնացորդի տարբերություն',
    waste: 'Կորուստ',
    drops: 'Կանխիկի հանձնում',
    expenses: 'Դրամարկղի ծախս',
    b2b: 'Գնորդի ՀՎՀՀ',
    taxType: 'Հարկի տեսակ',
    taxVat: 'ԱԱՀ-ով հարկվող',
    taxExempt: 'ԱԱՀ-ից ազատված',
    taxTurnover: 'Շրջանառության հարկ',
    taxUnknown: 'Առանց բաժնի',
    departmentNo: 'Բաժնի համար',
    departmentName: 'Բաժին',
    kind: 'Տեսակ',
    kindSale: 'Վաճառք',
    kindReturn: 'Վերադարձ',
    kindVoid: 'Չեղարկում',
    kindComp: 'Անվճար',
    orderCash: 'Պատվերի կանխիկ',
    orderCard: 'Պատվերի քարտ',
    onHand: 'Առկա մնացորդ',
    stays: 'Մնալ',
    checkIn: 'Մուտք',
    checkOut: 'Ելք',
    room: 'Սենյակ',
    guest: 'Հյուր',
    nights: 'Գիշեր',
    paymentOption: 'Վճարման տարբերակ',
    paymentStatus: 'Վճարման կարգավիճակ',
    tender: 'Վճարում',
    source: 'Աղբյուր',
    net: 'Զուտ',
    supplier: 'Մատակարար',
    tin: 'ՀՎՀՀ',
    serial: 'Սերիա',
    goods: 'Ապրանք',
    qty: 'Քանակ',
    unit: 'Չափման միավոր',
    unitPrice: 'Միավորի գին',
    lineTotal: 'Տողի գումար',
    vat: 'ԱԱՀ',
    invoiceTotal: 'Հաշիվ-ապրանքագրի գումար',
    ingredient: 'Բաղադրիչ',
    systemQty: 'Համակարգի քանակ',
    countedQty: 'Հաշված քանակ',
    delta: 'Տարբերություն',
    value: 'Արժեք ընթացիկ ինքնարժեքով',
    note: 'Նշում',
    expected: 'Սպասվող',
    counted: 'Հաշված',
    status: 'Կարգավիճակ',
    category: 'Կատեգորիա',
    description: 'Նկարագրություն',
    amount: 'Գումար',
    compType: 'Անվճարի տեսակ',
    count: 'Քանակ',
    order: 'Պատվեր',
    fiscalNo: 'ՀԴՄ համար',
    incomeCode: 'Եկամտի հաշիվ',
    accountCode: 'Հաշվի կոդ',
    closeReason: 'Փակման պատճառ',
    sheetSales: 'Վաճառք',
    sheetTax: 'Հարկ',
    sheetOrders: 'Պատվերներ',
    sheetOnHand: 'Առկա մնացորդ',
    sheetStays: 'Մնալ',
    sheetReturns: 'Վերադարձ',
    sheetComps: 'Անվճար',
    sheetVoids: 'Չեղարկում',
    sheetPurchases: 'Գնումներ',
    sheetStock: 'Մնացորդ',
    sheetWaste: 'Կորուստ',
    sheetDrops: 'Կանխիկ',
    sheetExpenses: 'Ծախս',
    sheetB2b: 'ՀՎՀՀ',
  },
  staff: {
    title: 'Աշխատակիցներ',
    subtitle: 'Մարդիկ և նրանց վարձը։ Նոր դրույքը սկսում է ձեր ընտրած օրվանից։',
    add: 'Ավելացնել',
    edit: 'Խմբագրել',
    empty: 'Աշխատակիցներ դեռ չկան։ Ավելացրեք մեկին՝ ժամերը, աշխատավարձը և անվճարները գրանցելու համար։',
    noMatch: 'Ոչինչ չի գտնվել։',
    search: 'Փնտրել աշխատակցին…',
    nameRequired: 'Անունը պարտադիր է։',
    colName: 'Անուն',
    colPay: 'Վճարում',
    colHours: 'Ժամեր',
    colWage: 'Աշխատավարձ',
    colTip: 'Թեյավճար',
    colTotal: 'Ընդամենը',
    timesheet: 'Տաբել',
    timesheetHint: 'Յուրաքանչյուր տողը մեկ հերթափոխ է։ Ավարտը պետք է սկզբից ուշ լինի, և հերթափոխերը չեն կարող իրար ծածկել։',
    start: 'Սկիզբ',
    end: 'Ավարտ',
    prevDay: 'Նախորդ օր',
    nextDay: 'Հաջորդ օր',
    prevMonth: 'Նախորդ ամիս',
    nextMonth: 'Հաջորդ ամիս',
    viewDay: 'Օր',
    viewMonth: 'Ամիս',
    monthHint: 'Սեղմեք վանդակը՝ այդ մարդու ժամերը դնելու համար։',
    openDay: 'Բացել {{name}}՝ {{date}}',
    duration: '{{hours}} ժ {{mins}} ր',
    durationHours: '{{hours}} ժ',
    durationMins: '{{mins}} ր',
    fillDrag: 'Քաշեք՝ այս վանդակը պատճենելու համար։ Դատարկ վանդակը մաքրում է ծածկածները։',
    off: 'ԱԶԱՏ',
    markOff: 'Նշել որպես ազատ',
    offHint: 'Այս օրը ազատ է։ Այն չի հաշվվում որպես վճարվող ժամ։',
    overlaps: 'Համընկնումներ',
    showOverlaps: 'Ցույց տալ, թե ով է միաժամանակ',
    overlapEmpty: 'Այս օրը ժամեր չկան։',
    overlapNone: 'Ոչ ոք միաժամանակ չի աշխատում։',
    copyToChecked: 'Պատճենել նշվածներին',
    copySlot: 'Պատճենել այս ժամերը',
    copyTimes: 'Պատճենել ժամերը',
    copyApply: 'Կիրառել',
    copyNoOne: 'Այս օրը ուրիշ մարդ չկա։',
    addShift: 'Ավելացնել հերթափոխ',
    sheetSaved: 'Պահված է',
    sheetIncomplete: 'Յուրաքանչյուր հերթափոխի համար պետք է և՛ սկիզբ, և՛ ավարտ։',
    sheetOrder: 'Ավարտը պետք է սկզբից ուշ լինի։',
    sheetOverlap: 'Նույն մարդու հերթափոխերը չեն կարող իրար ծածկել։',
    payHourly: 'Ժամավճար',
    payShift: 'Հերթափոխ',
    payMonthly: 'Ամսական',
    perHour: '/ ժամ',
    perShift: '/ հերթափոխ',
    perMonth: '/ ամիս',
    rate: 'Դրույք',
    effectiveFrom: 'Գործում է սկսած',
    effectiveHint: 'Այս օրվանից առաջ օրերը պահում են նախորդ դրույքը։',
    since: 'Սկսած {{date}}',
    clockIn: 'Մուտք',
    clockOut: 'Ելք',
    clockedIn: 'Մուտք՝ {{time}}',
    notIn: 'Դուրս է',
    punches: 'Մուտքեր',
    punchesName: '{{name}}',
    newPunch: 'Նոր մուտք',
    noPunches: 'Այս միջակայքում մուտքեր չկան։',
    clockInAt: 'Մուտք',
    clockOutAt: 'Ելք',
    breakMinutes: 'Ընդմիջում (րոպե)',
    note: 'Նշում',
    openPunch: 'Դեռ ներսում',
    punchRequired: 'Մուտքի ժամը պարտադիր է։',
    punchOrder: 'Ելքը պետք է մուտքից հետո լինի։',
    totalPeople: 'Մարդիկ',
    totalHours: 'Ժամեր',
    totalWages: 'Աշխատավարձ',
    wageNote:
      'Վճարված պատվերների թեյավճարը բաժանվում է ըստ ժամերի։ Աշխատավարձը հաշվվում է այդ օրվա դրույքով։',
    deleteTitle: 'Հեռացնե՞լ {{name}}-ին',
    deleteBody: 'Մուտքերը կջնջվեն։ Նախկին անվճարները կմնան պատվերի վրա, առանց այս անվան։',
    active: 'Ակտիվ',
    onTimesheet: 'Տաբելում',
    onTimesheetHint: 'Անջատեք, եթե մարդը միայն անվճար է ստանում։ Նա մնում է դրամարկղում և դուրս է ժամերից, աշխատավարձից ու թեյավճարից։',
    compOnly: 'Միայն անվճար',
    rateHistory: 'Դրույքների պատմություն',
    rateInForce: 'Գործում է',
    rateDeleteTitle: 'Հեռացնե՞լ {{date}}-ի դրույքը',
    rateDeleteBody: 'Այդ օրվանից նորից կգործի նախորդ դրույքը։',
    sort: 'Հերթականություն',
  },
} as const;
